import { Component, OnInit, OnDestroy, Sanitizer } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ngxCsv } from 'ngx-csv/ngx-csv';
// import * as $ from 'jquery';
import diff from 'fast-diff';
import QuillType from 'quill';
declare module 'quill';
import Delta from 'quill';
import { Quill } from 'quill';
import { EditorChangeContent, EditorChangeSelection } from 'ngx-quill';
declare module 'quill';
import {
  faComments,
  faEnvelopeSquare,
  faAngleDown,
  faBars,
  faBell,
  faChartLine,
  faClipboardList,
  faCog,
  faBookOpen,
  faConciergeBell,
  faCubes,
  faEnvelope,
  faExchangeAlt,
  faBook,
  faKey,
  faLanguage,
  faLink,
  faListOl,
  faBrain,
  faInfoCircle,
  faRobot,
  faLock,
  faMountain,
  faObjectGroup,
  faPencilAlt,
  faFile,
  faPenNib,
  faRunning,
  faSave,
  faCloudDownloadAlt,
  faSignOutAlt,
  faSkiing,
  faStickyNote,
  faTachometerAlt,
  faTasks,
  faTh,
  faUnlink,
  faUnlock,
  faUser,
  faUsers,
  faBug,
  faSitemap
} from '@fortawesome/free-solid-svg-icons';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { AppService } from '../shared/services/app.service';
import { CookieService } from 'ngx-cookie-service';
import { UserManagementService } from '../shared/services/user-management.service';
declare var $: any;
import { Config } from '../config';
import { NotificationsComponent } from '../notifications/notifications.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import * as io from 'socket.io-client';
import { Observable, Observer, fromEvent, merge, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { SocketService } from '../shared/services/socket.service';
import { environment } from '../../environments/environment';
import { JiraUserService } from '../shared/services/jira-user.service';
import { DomSanitizer } from '@angular/platform-browser';
// import { TaskPlannerComponent } from '../task-planner/task-planner.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  // Icons
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  faComments = faComments;
  faConciergeBell = faConciergeBell;
  faBars = faBars;
  faCloudDownloadAlt = faCloudDownloadAlt;
  faCog = faCog;
  faAngleDown = faAngleDown;
  faBookOpen = faBookOpen;
  faMountain = faMountain;
  faConnectdevelop = faConnectdevelop;
  faCubes = faCubes;
  faRobot = faRobot;
  faObjectGroup = faObjectGroup;
  faTasks = faTasks;
  faFile = faFile;
  faSkiing = faSkiing;
  faBrain = faBrain;
  faBook = faBook;
  faPenNib = faPenNib;
  faListOl = faListOl;
  faRunning = faRunning;
  faClipboardList = faClipboardList;
  faTh = faTh;
  faTachometerAlt = faTachometerAlt;
  faChartLine = faChartLine;
  faUnlock = faUnlock;
  faLock = faLock;
  faLink = faLink;
  faUnlink = faUnlink;
  faBell = faBell;
  faBug = faBug;
  faSitemap = faSitemap;
  faStickyNote = faStickyNote;
  faExchangeAlt = faExchangeAlt;
  faSave = faSave;
  faUsers = faUsers;
  faPencilAlt = faPencilAlt;
  faLanguage = faLanguage;
  faKey = faKey;
  faEnvelope = faEnvelope;
  faSignOutAlt = faSignOutAlt;

  languages: any = [
    { short: 'en', fullform: 'English' },
    { short: 'jp', fullform: 'Japanese' },
  ];
  newProject: any = {};
  validateAPIKey = false;
  currProject: any = { projectDetails: { name: '', description: '' }, jiraProjectDetails: { name: '', id: '', url: '', key: '' } };
  // newProject:any = { projectDetails: { name: '', description: '' } };
  // currProject:any = { projectDetails: { name: '', description: '' } };
  projects: any = [{ projectDetails: { name: '', description: '' } }];
  projectsMgmtList: any = [{ projectDetails: { name: '', description: '' } }];
  templates: any;
  templateNames: any;
  slideTimeOut: any;
  feedbackEditorContent: any = '';
  feedbackMethod = 'Suggestion';
  feedbackSubject: any = '';
  feedbackErrorMessage = '';
  currSession: any;
  selectedAssistantModel: any = '';
  widgetContent: any;
  widgetContentDesigner: any;
  getApplication: any = {};
  currentActiveUsers: any = [];
  downloadFileName: any = '';
  tutorialsProjects: any = [];
  selectedTutorialProject: any = {};
  selectedTutorialName: any = '';
  currentActiveUsersCount: any = 0;
  selectedProject: any;
  userName: any;
  myNotesOpen: any = false;
  activeusername: any;
  changepwd = { oldpassword: '', newpassword: '', confirmpassword: '' };
  language: any;
  dropdownTitle: any = true;
  project: any;
  timer: any;
  projectMenuError: any;
  menu: any = {
    orgmgmt: { show: false },
    language: { show: false },
    report: { show: false },
  };
  disableLinks: any;
  notification: any;
  deleteConfirmationMode: any;
  jottingApp: any;
  projectOpen: any;
  projectUserListIds: any = [{ _id: '', username: '', firstname: '' }];
  userDisplayName: any;
  optradio: any;
  selectedWidgetID: any = '';
  selectedWidgetType: any = '';
  selectedWidgetDetails: any = {};
  importCheck: any;
  listOfparams: any = [];
  taskPlannerList: any;
  myTaskPlannerList: any;
  importComplete: any;
  exportReportArray: any = [];
  activityPageName: any = '';
  noDataPopupMsg: any = '';
  videoURL: any;
  sessionId: any = '';
  groups: any;
  currGroup: any;
  currGroupCreateProject: any;
  selectedGroup: any;
  inviteMailId: any = '';
  userList: any;
  projectUserList: any = [];
  orgUserListByProject: any = [];
  selectedUsrToAdd: any = [];
  selectedUsrToRemove: any;
  isUsrAddDisabled: any = true;
  isUsrRemoveDisabled: any = true;
  isPrjMrmtDisabled: any = false;
  loginDetails: any;
  userrole: any;
  selectToRemoveUsr: any;
  selectAdmin: any;
  selectedPlannameInDesigner: any;
  orgUserList: any = [];
  readStatus: any = false;
  addProjectBtnDisabled: any = false;
  disableReadModeBtn: any;
  currentStateReadModeBtn: any;
  currentReadStatus: any;

  sessionHistoryArray: any = [];
  toggleTreeBranchIcons: any;
  TFToggleStatus: any = false;
  URToggleStatus: any = false;
  BFToggleStatus: any = false;
  XXToggleStatus: any = false;
  interactionTFToggleStatus: any = false;
  interactionURToggleStatus: any = false;
  interactionBFToggleStatus: any = false;
  interactionXXToggleStatus: any = false;
  scopeTFToggleStatus: any = false;
  scopeURToggleStatus: any = false;
  scopeBFToggleStatus: any = false;
  scopeXXToggleStatus: any = false;
  currentSlideId: any;
  inviteMessage: any = '';
  userDeleteMessage: any = '';
  updatePlanname: any = false;
  activeProject: any = {};
  messageContent: any = '';
  chatUsersList: any = [];
  chatMessages: any = [];
  networkConnection: any = true;
  chatUpdateColor: any = false;
  chatPopupOpened: any = false;
  myUserID: any = localStorage.getItem('userID');
  mySocketID = this.uniqueEID();
  oldProjectID: any = localStorage.getItem('projectID');
  oldApplication: any;
  toastMsgUserStatus: any = '';
  skipPublicWidgetCount: any = 0;
  skipPrivateWidgetCount: any = 0;
  maxWidgetCount: any = 0;
  projectsLoaded: any = false;
  delProUsers: any = [];
  activeUsersDetails: any = [];
  activeUsersNames: any = '';
  allPublicPublishedWidgets: any = [];
  allPrivatePublishedWidgets: any = [];
  currentView: any = localStorage.getItem('currentTool') || 'projectSelect';
  currentTool: any;
  content: any;
  importedProject: any;
  currProjectName: any;
  $fileContent: any;
  toastMsg: any;
  token: any;
  projectData: any = {};
  currentToolname: any;
  currentToolName: any = localStorage.getItem('currentTool');
  sessionProjectData: any = {
    persona: [],
    listOfEUTs: [],
    listOfEnv: [],
    projectDetails: { name: '' },
  };
  updatedTaskList: any;
  finalTaskList: any;
  entityTypeScenario: any;
  currProjectInPrjMgmt: any;
  modelDataCopy: any = '';
  clientSocketID: any;
  selectAll: any;
  errors: any;
  IMcheckboxReadOnly: any;
  HighlightRow: any = 0;
  ClickedRow: any;
  modelData: any = {
    persona: [],
    listOfEUTs: [],
    listOfEnv: [],
    projectDetails: { name: '' },
  };
  lastUpdatedDataModel: any;
  /// temp vars
  loader: boolean = false;
  taskPlanner: any = {};
  taskPlanner1: any = {};
  personaMapper: any = {};
  scopeMapper: any = {};
  interactionMapper: any = {};
  dashboard: any = {};
  deepDive: any = {};
  checklist: any = {};
  testDesigner: any = { model: { duplicateScenario: '' } };
  validator: any = { controller: { duplicateScenario: '' } };
  widget: any = {};
  selectedApplication: any = { "name": '' };
  personaMapperMindmap: any = {};
  interactionMapperMindmap: any = {};
  view: any = {};
  jiraLogin: any = { username: '', password: '', jiraurl: 'https://dosmarttesting.atlassian.net' };

  assistantSetup: any = { maxtokens: 500, token: '' };
  // jiraLogin: any = { username: '', password: '', jiraurl: '' };
  showJiraprojectList: Boolean = false;
  jiraProjectList: any = [];
  jiraStoriesList: any = [];
  doSmartQAProjectList: any = [];
  selectedJiraProject: any = {};
  applicationsList: any = [];
  selectedDoSmartQAProject: any = { projectDetails: { name: "" }, jiraProjectDetails: { name: "", id: "", url: '', key: '' } };
  jiraProjectUrDetails: any;
  focusMode: any = false;
  private socket: SocketIOClient.Socket;
  changePwdMessage: any = '';
  entitiesScenariosReport: any = [];
  chatGPTOpen: any = false;
  selectedProjectSaveLocation: any = '';
  uploadFileName: any;
  selectedProjectSource: any = '';
  assistantModelsList: any;
  formattedDate: any;
  CSVdownloadFileName: any;
  selectedSuite: any;
  mindMapData: any = '';
  nodeData: any = '';
  summaryTypes = ["By Test", "By Level", "By Type"];
  selectedEntityScenarios: any = [];
  selectedEntityScenarioTestTypes: any = [];
  childrenArray: any = [];
  levelwiseCount: any = [{ "level": "L8", "count": 0 }, { "level": "L7", "count": 0 }, { "level": "L6", "count": 0 }, { "level": "L5", "count": 0 }, { "level": "L4", "count": 0 }, { "level": "L123", "count": 0 }];
  TypeswiseCount: any = [{ "type": "+", "count": 0 }, { "type": "-", "count": 0 }];
  TestTypewiseCount: any = [{ "test": "Fe", "name": "Feature Behaviour", "count": 0 }, { "test": "Rb", "name": "Requirement Behaviour", "count": 0 }, { "test": "Fb", "name": "Flow Behaviour", "count": 0 }, { "test": "Ls", "name": "Load & Stress", "count": 0 }, { "test": "Pf", "name": "Performance", "count": 0 }, { "test": "Se", "name": "Security", "count": 0 }, { "test": "Us", "name": "Usability", "count": 0 }, { "test": "Cm", "name": "Compatibility", "count": 0 }, { "test": "Vo", "name": "Volume", "count": 0 }, { "test": "Re", "name": "Reliability", "count": 0 }, { "test": "Mi", "name": "Migration", "count": 0 }];
  resultArrays: any = [];
  finalResultArray: any = [];
  filteredText: any;
  entityTypes = ["XX", "TF", "UR", "BF"];
  editorContentText: any = '';
  notesEditorContent: any;
  membership: any;
  constructor(
    public translate: TranslateService,
    private router: Router,
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private AppService: AppService,
    private cookieService: CookieService,
    private userManagementService: UserManagementService,
    public Config: Config,
    private appService: AppService,
    public notificationsComponent: NotificationsComponent,
    // public TaskPlannerComponent: TaskPlannerComponent,
    public dashboardComponent: DashboardComponent,
    private JiraUserService: JiraUserService,
    private sanitizer: DomSanitizer
  ) {
    // translate.setDefaultLang('en');
    const browserLang = this.cookieService.get('language');
    this.language = browserLang;
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
    this.ClickedRow = (index: any) => {
      this.HighlightRow = index;
    };
    this.activeusername = this.cookieService.get('activeusername');
    let userDetal = JSON.stringify({
      userID: this.myUserID,
      userName: this.activeusername,
      socketID: this.mySocketID,
      active: true,
    });
    localStorage.setItem('socketID', this.mySocketID);

    this.socket = io.connect(environment.socketURL, {
      transports: ['websocket'],
      upgrade: false,
      query: 'details=' + userDetal + '',
    });

    // console.log('socket', this.socket);
    this._sharedService.socketDetailsLoad(this.socket);
  }

  ngOnInit(): void {
    this.createOnline$().subscribe((isOnline) => {
      // console.log('log in init of main', isOnline);
      if (isOnline == true) {
        // console.log('true exist');
        if (this.networkConnection == false) {
          // console.log('Came online, Internet reconnected');
          let userDetal = JSON.stringify({
            userID: this.myUserID,
            userName: this.activeusername,
            socketID: this.mySocketID,
            active: true,
          });
          // console.log('userDetal', userDetal);
          // this.socket = io.connect('', { transports: ['websocket'], upgrade: false, query: "details=" + userDetal + '' });
          this.socket = io.connect(environment.socketURL, {
            transports: ['websocket'],
            upgrade: false,
            query: 'details=' + userDetal + '',
          });
          this.updateActiveProject();
          var curProID = localStorage.getItem('projectID');
          this.ProjectServices.loadProject(
            this.currProject,
            curProID
          ).subscribe((response: any) => {
            this.sessionProjectData = response.model;
            this._sharedService.projectDataLoad(response);
            this.modelData = response.model;
            this.lastUpdatedDataModel = response.model;
            this.modelDataCopy = JSON.stringify(response.model);
            this.socketService.triggerTool();
          });
          this.networkConnection = true;
          // console.log('this.networkConnection', this.networkConnection);
          if (this.currentStateReadModeBtn == true) {
            this.disableReadModeBtn = true;
            if (this.currentReadStatus == true) {
              this.readStatus = true;
              this.readmode(true);
            } else {
              this.readStatus = false;
              this.readmode(false);
            }
          } else {
            this.disableReadModeBtn = false;
            if (this.currentReadStatus == true) {
              this.readStatus = true;
              this.readmode(true);
            } else {
              this.readStatus = false;
              this.readmode(false);
            }
          }
        }
      } else {
        // console.log('Came offline, Internet disconnected');
        this.networkConnection = false;
        // console.log('this.networkConnection', this.networkConnection);
        if (this.disableReadModeBtn == true) {
          this.currentStateReadModeBtn = true;
          if (this.readStatus == true) {
            this.currentReadStatus = false;
            this.disableReadModeBtn = true;
            this.readmode(false);
          } else {
            this.currentReadStatus = true;
            this.disableReadModeBtn = true;
            this.readmode(false);
          }
        } else {
          this.currentStateReadModeBtn = false;
          if (this.readStatus == true) {
            this.currentReadStatus = false;
            this.disableReadModeBtn = true;
            this.readmode(false);
          } else {
            this.currentReadStatus = true;
            this.disableReadModeBtn = true;
            this.readmode(false);
          }
        }
      }
    });

    this.loginDetails = JSON.parse(
      localStorage.getItem('loginDetails') || '{}'
    );
    // console.log('this.loginDetailsoff', this.loginDetails);
    this.userName = this.loginDetails.user_display_name;
    if (this.loginDetails.newlogin === 0) {
      this.userDisplayName = this.loginDetails.user_display_name;
      $('#welcomeNotePopup').modal('show');
    }
    this.token = this.loginDetails.token;
    this.userrole = this.loginDetails.userrole;
    this.currentTool = localStorage.getItem('currentTool');
    var membership = window.localStorage.getItem("membership");
    if (membership) {
      this.membership = membership;
      window.localStorage.removeItem("membership");
    }
    // console.log('curr', this.currentTool);

    // if (localStorage.getItem('currentTool') == 'null') {
    //   this.openTool('projectSelect');
    // } else {
    //   this.openTool(localStorage.getItem('currentTool'));
    // }

    if (this.focusMode == false) {
      if (this.currentTool == null) {
        // console.log('if exist');
        this.openTool('projectSelect');
      } else if (this.currentTool == 'projectSelect') {
        // console.log('else if exist');
        this.openTool('projectSelect');
      } else {
        // console.log('else exist');
        this.ProjectServices.getProject(
          localStorage.getItem('projectID')
        ).subscribe((response: any) => {
          if (response.statusCode == 200) {
            this.startSession(response.record, false, '');
          } else {
          }
        });
      }
    } else {
      this.openTool('entityTest');
    }

    let socketID: any = window.localStorage.getItem('socketID');
    this.socket.on(socketID, (res: any) => {
      // console.log('res socket1234', res);
      if (res.statusCode == 201) {
        let tempObj = {
          message: 'Denied',
          statusCode: 202,
          socketID: res.socketID,
        };
        this.socket.emit('loginduplicate', JSON.stringify(tempObj));
      }
    });
    this.getAllMessages();
    this.appService.loadVideoLinks();

    this.newProject = {};

    this.resetMenu();
    // HeaderService.wireUpEventHandlers();
    this.userName = this.cookieService.get('UserName');
    this.language = this.cookieService.get('language');
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });

    this.getApplicationList(this.token);

    this.selectedProjectSource = window.localStorage.getItem("source");
    // this.oldApplication = JSON.parse(applicationData);
    // this.loadProjectMenu(this.oldApplication);
  }
  activateLoader(status: any) {
    this.loader = status;
  }
  selectTutorial(project: any, id: any) {
    this.selectedTutorialProject = project;
    this.selectedTutorialProject["_id"] = id;
    this.selectedTutorialName = project.name;
  }
  tutorialProjects() {
    this.ProjectServices.getTutorialProjects().subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.tutorialsProjects = response.record;
        } else if (response.statusCode === 500) {
        }
      })
  }
  downloadTutorial() {
    let selectedTutorial = this.tutorialsProjects.find((project: any) => project._id == this.selectedTutorialProject._id);
    if (selectedTutorial) {
      this.downloadProjectData(selectedTutorial, "Tutorial");
    }
  }
  downloadProjectData(modelData: any, prefix: any) {
    // Convert JSON data to a string
    var data = JSON.stringify(modelData);
    // Create a Blob object to represent the data
    var blob = new Blob([data], { type: 'application/json' });
    // Create a link element to download the JSON data
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = modelData.projectDetails.name + ".json";
    if (prefix) {
      link.download = modelData.projectDetails.name + ".json";
    }
    // Append the link to the body and click on it
    document.body.appendChild(link);
    link.click();
    // this.projectModelUpdated = false;
    // Remove the link after a second
    setTimeout(function () {
      document.body.removeChild(link);
    }, 1000);
    // this._sharedService.projectContent(this.modelData);
  }
  showContent(event: any) {
    const fileToLoad = event.target.files[0];
    console.log(event.target.location);
    console.log(fileToLoad);
    this.uploadFileName = fileToLoad.name;
  }

  selectProjectSavelocation(model: any) {
    this.selectedProjectSaveLocation = model;
  }
  selectAssistantModel(model: any) {
    this.selectedAssistantModel = model;
    this.validateAPIKey = false;
  }
  openMoreInforPage() {
    this.ProjectServices.getMoreInfoLink().subscribe(
      (response: any) => {
        if (response) {
          const url = response[0].personalEdition;
          window.open(url, '_blank');
        } else {
          const url = "https://stagsoftware.com/";
          window.open(url, '_blank');
        }
      })
  }
  assistantModels() {
    this.ProjectServices.getAssistantModelsData().subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.assistantModelsList = response.record;
          console.log("this.assistantModelsList", this.assistantModelsList);
        } else if (response.statusCode === 500) {
        }
      })
  }
  generateDownloadFileName() {
    const currentDate = new Date();
    const monthAbbreviation = currentDate.toLocaleString('default', { month: 'short' });
    const day = String(currentDate.getDate()).padStart(2, '0');
    const year = currentDate.getFullYear();
    var formatDate = `${monthAbbreviation}${day}${year}`;
    this.formattedDate = `${monthAbbreviation} ${day}, ${year}`;
    let eutfirstFiveChars = this.modelData.projectDetails.name.substring(0, 5).trim();
    this.downloadFileName = eutfirstFiveChars + '_' + formatDate;
    this.CSVdownloadFileName = eutfirstFiveChars + '_' + formatDate + '.csv';
  }
  generateScenariosReport() {
    this.entitiesScenariosReport = [];

    for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
      for (var j = 0; j < this.modelData.scenarios.length; j++) {

        if (this.modelData.listOfEUTs[i].eID == this.modelData.scenarios[j].eID) {
          var testType = this.modelData.scenarios[j].attribute.symbol;
          // if (testType == 'Fe' || testType == 'Fb' || testType == 'Rb') {
          var obj = {
            "Module name": this.getModuleName(this.modelData.listOfEUTs[i]),
            "Entity name": this.modelData.listOfEUTs[i].eName,
            "Test type": this.modelData.scenarios[j].attribute.symbol,
            "Level": this.modelData.scenarios[j].attribute.level,
            "Type": this.modelData.scenarios[j].cr,
            "Scenarios": this.modelData.scenarios[j].description
          }
          this.entitiesScenariosReport.push(obj);
          // }

        }

      }
    }
    this.downloadCSV();
  }

  downloadCSV() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm: any = today.getMonth() + 1; // Months start at 0!
    let dd: any = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const formattedToday = dd + '/' + mm + '/' + yyyy;
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: window.localStorage.getItem("projectName") + ', Generate on (' + formattedToday + '), Note: please sort/filter to read.',
      useBom: true,
      noDownload: false,
      headers: ["Module name", "Entity name", "Test type", "Level", "Type", "Scenario"]
    };


    let lastThreeChars = this.CSVdownloadFileName.substring(this.CSVdownloadFileName.length - 3);
    var fileName = ""
    if (lastThreeChars == "csv") {
      fileName = this.downloadFileName;
    } else {
      fileName = this.CSVdownloadFileName;
    }
    new ngxCsv(this.entitiesScenariosReport, fileName, options);
  }
  //function to get modulename by moduleID
  getModuleName(eut: any) {
    var foundModule: any = this.modelData.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  chooseApplication(app: any) {
    this.selectedApplication = app;
    // console.log(this.selectedApplication);
    this.loadProjectMenu(this.selectedApplication);
    window.localStorage.setItem("application", JSON.stringify(this.selectedApplication));
  }
  getApplicationList(token: any) {
    this.ProjectServices.getapplicationList(token).subscribe((response: any) => {
      if (response.statusCode == 200) {
        // console.log('Application', response);
        this.applicationsList = response.records;
        if (this.applicationsList.length > 0) {
          var application_ID = window.localStorage.getItem("applicationID");

          if (application_ID == null || application_ID == undefined) {
            this.selectedApplication = this.applicationsList[0];
            this.loadProjectMenu(this.applicationsList[0]);
          } else {
            this.getApplication = this.applicationsList.find(
              (app: any) => app._id == application_ID
            );
            // console.log("this.getApplication", this.getApplication);
            this.selectedApplication = this.getApplication;
            this.loadProjectMenu(this.getApplication);
          }

        }

      }
    })
  }
  createOnline$() {
    return merge<boolean>(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
  }
  onFocusModeBeforeProject(checked: any) {
    // console.log(checked);
    this.focusMode = checked;
    window.localStorage.setItem("focusMode", checked);
  }
  onFocusMode(checked: any) {
    // console.log(checked);
    this.focusMode = checked;
    // window.localStorage.setItem("focusMode",checked);
    if (checked == true) {
      this.openTool('entityTest');
      // this.router.navigateByUrl('/entityTest');
    } else {
      this.openTool('landscaper');
      // this.router.navigateByUrl('/landscaper');
    }
  }
  checkFocusMode() {
    if (this.focusMode == true) {
      return true;
    } else {
      return false;
    }
  }
  openTool(toolname: any) {
    this.currentView = toolname;
    localStorage.setItem('currentTool', toolname);
  }

  getProjectTasksList(proDetails: any) {
    // console.log('proDetails', proDetails);
    // console.log('this.loginDetails', this.loginDetails);
    if (proDetails.jiraProjectDetails.url) {
      this.jiraProjectUrDetails = this.loginDetails.jiraDetails.find(
        (det: any) => det.url == proDetails.jiraProjectDetails.url
      );
      this.jiraLogin = { username: this.jiraProjectUrDetails.email, password: this.jiraProjectUrDetails.token, jiraurl: this.jiraProjectUrDetails.url };
      let authorizationData = 'Basic ' + btoa(this.jiraProjectUrDetails.email + ':' + this.jiraProjectUrDetails.token);
      this.JiraUserService.getAllJiraStories(authorizationData, proDetails.jiraProjectDetails, 1).subscribe((response: any) => {
        // console.log("getAllJiraStories", response);
        this.jiraStoriesList = response.issues;
        this._sharedService.loadJiraProjectData(response.issues);
      });
    } else {
      // this.jiraLogin = { username: '', password: '', jiraurl: '' };
    }
  }

  startSession(currProject: any, isTask: any, createdProjectId: any) {
    // console.log('main session called', currProject);

    // if (currProject !== '' && createdProjectId !== '') {
    $('.spinner').show();
    this.activateLoader(true);
    localStorage.removeItem('sessionID');

    this.ProjectServices.loadProject(currProject, createdProjectId).subscribe(
      (response: any) => {
        // console.log('this.currentToolName', this.currentToolName);
        // this.getProjectTasksList(response.model);  // error while new invited user
        // this.project = new Project(response);
        this.projectOpen = true;
        this._sharedService.projectDataLoad(response);
        this.sessionProjectData = response.model;
        // console.log('sessionProjectData', this.sessionProjectData);
        this.modelData = response.model;
        this.checkScenarioCount(
          this.modelData.scenarios,
          this.modelData.listOfEUTs
        );
        this.lastUpdatedDataModel = response.model;
        // this.openTool('landscaper');
        // this.createActivity('Ls');
        if (this.currentToolName == null) {
          // if (this.focusMode == true) {
          //   this.openTool('entityTest');
          //   this.createActivity('Et');
          // } else {
          this.openTool('landscaper');
          this.createActivity('Ls');
          this.activateLoader(false);
          // }
        } else if (this.currentToolName == 'projectSelect') {
          // if (this.focusMode == true) {
          //   this.openTool('entityTest');
          //   this.createActivity('Et');
          // } else {
          this.openTool('landscaper');
          this.createActivity('Ls');
          // }

        } else {
          var tool = this.currentToolName;
          if (
            tool == 'Ls' ||
            tool == 'Pm' ||
            tool == 'Pmm' ||
            tool == 'Im' ||
            tool == 'Imm' ||
            tool == 'Sc' ||
            tool == 'Scm' ||
            tool == 'Ed' ||
            tool == 'Tp1' ||
            tool == 'Dd' ||
            tool == 'Td' ||
            tool == 'Ex' ||
            tool == 'Cl' ||
            tool == 'Db'

          ) {
            this.currentToolName = 'landscaper';
          }
          //  else if()
          this.openTool(this.currentToolName);
          this.createActivity(this.getToolShortName(this.currentToolName));
        }

        // this.project.model.sendLandscape(this.landscape);
        // this.appMgr = new AppManager(
        //   this.deepDive.model,
        //   this.testDesigner.model
        // );       
        this.updateHistorySession(this.modelData._id);
        // $('.readOnlyModeBtn').css('display', 'block');
        $('.readOnlyModeBtn').removeClass('displayNone');
        $('.readOnlyModeBtn').addClass('displayBlock');
        if (currProject.projectDetails.readOnly == true) {
          setTimeout(() => {
            this.readmode(false);
            this.disableReadModeBtn = true;
          }, 2000);
        }
        this.addProjectBtnDisabled = false;
      }
    );
    this.getOrgProjectUsers(currProject);
    this.getProjectUsers(currProject);
    let userID = this.myUserID;
    if (createdProjectId) {
      this.activeProject = { projectId: createdProjectId, userId: userID };
    } else {
      this.activeProject = { projectId: currProject._id, userId: userID };
    }
    this.updateActiveProject();
    this.notificationsComponent.getNotifications();
    // console.log('this.activeProject.userId', this.activeProject.userId);
    this.socket.on(
      this.activeProject.userId,
      (updatedUsers: any, userData: any) => {
        // console.log('updatedUsers', updatedUsers);
        this.currentActiveUsers = updatedUsers;
        this.currentActiveUsersCount = updatedUsers.length - 1;
        // console.log('userData', userData);
        if (userData.userId != this.myUserID) {
          let userStatus = userData.username + ' ' + userData.status;
          if (this.disableReadModeBtn != true) {
            this.triggerToastUser(userStatus);
          }
        }
      }
    );

    this.socket.on(
      'editorContent' + this.activeProject.projectId + this.myUserID,
      (res: any) => {
        // console.log('editorContent socket res', res);
        if (this.currentActiveUsersCount >= 1) {
          // if (res.type == 'scenarioContent') {
          //   if (this.currentToolname === 'Ex') {
          //     this.validator.controller.quillNoteReload();
          //   } else if (this.currentToolname === 'Td') {
          //     this.testDesigner.controller.quillNoteReload();
          //   }
          // } else if (res.type == 'checklistContent') {
          //   if (this.currentToolname === 'Cl') {
          //     this.checklist.controller.checklistNoteReload();
          //   }
          // }
        }
      }
    );
    // $window.scrollTo(0, 0);
    // this.updateHistorySession();
    // }

    setInterval(() => {
      this.autosave();
    }, 1000);
  }

  createActivity(appname: any) {
    // console.log('appname', appname);
    if (
      appname != 'Db' &&
      appname != 'Lo' &&
      appname != 'Nt' &&
      appname != 'Snt' &&
      appname != 'No' &&
      appname != 'XX' &&
      appname != 'Tdsp' &&
      appname != 'Tdsc' &&
      appname != 'Tdde' &&
      appname != 'Exsc' &&
      appname != 'Exde' &&
      appname != 'Exsp'
    ) {
      this.currentToolName = appname;
      this.getVideoURL(appname);
    }
    var sessionID = localStorage.getItem('sessionID');
    var projectID = localStorage.getItem('projectID');
    var userID = localStorage.getItem('userID');
    if (sessionID == null) {
      sessionID = '';
    }
    let activityData = {
      appname: appname,
      sessionid: sessionID,
      projectid: projectID,
      userid: userID,
    };

    this.AppService.updateActivity(activityData).subscribe((response: any) => {
      // console.log('updateActivity response', response);
      if (response.statusCode === 200) {
        if (response.sessionid != undefined) {
          localStorage.setItem('sessionID', response.sessionid);
          this.notificationsComponent.getNotifications();
        }
        if (localStorage.getItem('sessionID') != undefined && appname == 'No') {
          this.notificationsComponent.getNotifications();
        }
      }
    });
  }

  // function to get tool full name open
  getToolName(toolName: string) {
    var name;
    switch (toolName) {
      case 'Ls':
        name = 'Landscaper';
        break;
      case 'Pm':
        name = 'Persona Mapper';
        break;
      case 'Pmm':
        name = 'Persona Mapper Mind Map';
        break;
      case 'Im':
        name = 'Interaction Mapper';
        break;
      case 'Imm':
        name = 'Interaction Mapper Mind Map';
        break;
      case 'Sc':
        name = 'Scope Mapper';
        break;
      case 'Scm':
        name = 'Scope Mapper Mind Map';
        break;
      case 'Ed':
        name = 'Environment Mapper';
        break;
      case 'Tp1':
        name = 'Task Planner';
        break;
      case 'Sp':
        name = 'Sprint Planner';
        break;
      case 'Sp1':
        name = 'Sprint Planner Plus';
        break;
      case 'Dd':
        name = 'Deep Dive';
        break;
      case 'Td':
        name = 'Test Designer';
        break;
      case 'Tdsp':
        name = 'Test Designer Specs';
        break;
      case 'Tdsc':
        name = 'Test Designer Scenarios';
        break;
      case 'Tdde':
        name = 'Test Designer Note';
        break;
      case 'Ex':
        name = 'Executor';
        break;
      case 'Exsp':
        name = 'Executor Specs';
        break;
      case 'Exsc':
        name = 'Executor Scenarios';
        break;
      case 'Exde':
        name = 'Executor Note';
        break;
      case 'Tm':
        name = 'Test Manager';
        break;
      case 'Db':
        name = 'Dashboard';
        break;
      case 'Cl':
        name = 'Checklist';
        break;
      case 'No':
        name = 'Notification';
        break;
      case 'Snt':
        name = 'SuperNote';
        break;
      case 'Nt':
        name = 'Note';
        break;
      case 'Lo':
        name = 'logout';
        break;
      case 'Et':
        name = 'Entitytest';
        break;
    }
    return name;
  }

  // function to get tool short name open
  getToolShortName(toolName: string) {
    var name;
    switch (toolName) {
      case 'landscaper':
        name = 'Ls';
        break;
      case 'personaMapper':
        name = 'Pm';
        break;
      case 'personaMapperMindMap':
        name = 'Pmm';
        break;
      case 'interactionMapperMindMap':
        name = 'Imm';
        break;
      case 'interactionMapper':
        name = 'Im';
        break;
      case 'scopeMapper':
        name = 'Sc';
        break;
      case 'scopeMapperMindMap':
        name = 'Scm';
        break;
      case 'environmentMapper':
        name = 'Ed';
        break;
      case 'taskPlanner':
        name = 'Tp1';
        break;
      case 'sprintPlanner':
        name = 'Sp';
        break;
      case 'sprintPlannerPlus':
        name = 'Sp1';
        break;
      case 'deepDive':
        name = 'Dd';
        break;
      case 'testDesigner':
        name = 'Td';
        break;
      case 'Test Designer Specs':
        name = 'Tdsp';
        break;
      case 'Test Designer Scenarios':
        name = 'Tdsc';
        break;
      case 'Test Designer Note':
        name = 'Tdde';
        break;
      case 'testExecutor':
        name = 'Ex';
        break;
      case 'Executor Specs':
        name = 'Exsp';
        break;
      case 'Executor Scenarios':
        name = 'Exsc';
        break;
      case 'Executor Note':
        name = 'Exde';
        break;
      case 'testManager':
        name = 'Tm';
        break;
      case 'dashboard':
        name = 'Db';
        break;
      case 'checklist':
        name = 'Cl';
        break;
      case 'Notification':
        name = 'No';
        break;
      case 'SuperNote':
        name = 'Snt';
        break;
      case 'Note':
        name = 'Nt';
        break;
      case 'logout':
        name = 'Lo';
        break;
      case 'Entitytest':
        name = 'Et';
        break;
    }
    return name;
  }

  // to get users from Org and Project
  getOrgProjectUsers(currProject: any) {
    this.userManagementService
      .getUsersFromOrgPrj(currProject)
      .subscribe((response: any) => {
        // console.log('getUsersFromOrgPrj res', response);
        if (response.statusCode == 200) {
          this.userList = response.records;
        }
      });
  }

  // to get users from project
  getProjectUsers(currProject: any) {
    this.projectUserListIds = [];
    this.userManagementService
      .getUsersFromProject(currProject)
      .subscribe((response: any) => {
        // console.log('getUsersFromProject res', response);
        if (response.statusCode == 200) {
          this.projectUserList = response.records;
          for (var p = 0; p < this.projectUserList.length; p++) {
            this.projectUserListIds.push(this.projectUserList[p]._id);
          }
        }
      });
  }

  goToView() {
    // console.log('view called in main component');
    window.open('/exportReport', '_blank');
    // window.open(appConst.redirectHostAddress + "export", "_blank");
  }

  goToCockpit() {
    window.open('/cockpitReport', '_blank');
    // window.open(appConst.redirectHostAddress + "cockpit", "_blank");
  }

  goToBlog() {
    window.open('https://s7.stagsoftware.com/', '_blank');
  }

  setDetaultToggleValues(mapper: any, TF: any, UR: any, BF: any, XX: any) {
    // console.log('setDetaultToggleValues mapper', mapper);
    // console.log('setDetaultToggleValues TF', TF);
    // console.log('setDetaultToggleValues UR', UR);
    // console.log('setDetaultToggleValues BF', BF);
    // console.log('setDetaultToggleValues XX', XX)

    if (mapper == 'Persona') {
      this.TFToggleStatus = TF;
      this.URToggleStatus = UR;
      this.BFToggleStatus = BF;
      this.XXToggleStatus = XX;
      this.interactionTFToggleStatus = false;
      this.interactionURToggleStatus = false;
      this.interactionBFToggleStatus = false;
      this.interactionXXToggleStatus = false;
      this.scopeTFToggleStatus = false;
      this.scopeURToggleStatus = false;
      this.scopeBFToggleStatus = false;
      this.scopeXXToggleStatus = false;
      if (this.TFToggleStatus == false) {
        $('.TFstage2').hide();
        $('.iconsTF').removeClass('fa-minus-circle');
        $('.iconsTF').addClass('fa-plus-circle');
      } else {
        $('.TFstage2').show();
        $('.iconsTF').removeClass('fa-plus-circle');
        $('.iconsTF').addClass('fa-minus-circle');
      }
      if (this.URToggleStatus == false) {
        $('.URstage2').hide();
        $('.iconsUR').removeClass('fa-minus-circle');
        $('.iconsUR').addClass('fa-plus-circle');
      } else {
        $('.URstage2').show();
        $('.iconsUR').removeClass('fa-plus-circle');
        $('.iconsUR').addClass('fa-minus-circle');
      }
      if (this.BFToggleStatus == false) {
        $('.BFstage2').hide();
        $('.iconsBF').removeClass('fa-minus-circle');
        $('.iconsBF').addClass('fa-plus-circle');
      } else {
        $('.BFstage2').show();
        $('.iconsBF').removeClass('fa-plus-circle');
        $('.iconsBF').addClass('fa-minus-circle');
      }
      if (this.BFToggleStatus == false) {
        $('.XXstage2').hide();
        $('.iconsXX').removeClass('fa-minus-circle');
        $('.iconsXX').addClass('fa-plus-circle');
      } else {
        $('.XXstage2').show();
        $('.iconsXX').removeClass('fa-plus-circle');
        $('.iconsXX').addClass('fa-minus-circle');
      }
    } else if (mapper == 'Inter') {
      this.TFToggleStatus = false;
      this.URToggleStatus = false;
      this.BFToggleStatus = false;
      this.XXToggleStatus = false;
      this.interactionTFToggleStatus = TF;
      this.interactionURToggleStatus = UR;
      this.interactionBFToggleStatus = BF;
      this.interactionXXToggleStatus = XX;
      this.scopeTFToggleStatus = false;
      this.scopeURToggleStatus = false;
      this.scopeBFToggleStatus = false;
      this.scopeXXToggleStatus = false;
      if (this.interactionTFToggleStatus == false) {
        this.router.navigateByUrl('/main/interactionMapperMindMap');
        $('.TFstage2Inter').hide();
        $('.iconsTF').removeClass('fa-minus-circle');
        $('.iconsTF').addClass('fa-plus-circle');
      } else {
        this.router.navigateByUrl('/main/interactionMapperMindMap');
        $('.TFstage2Inter').show();
        $('.iconsTF').removeClass('fa-plus-circle');
        $('.iconsTF').addClass('fa-minus-circle');
      }
      if (this.interactionURToggleStatus == false) {
        $('.URstage2Inter').hide();
        $('.iconsUR').removeClass('fa-minus-circle');
        $('.iconsUR').addClass('fa-plus-circle');
      } else {
        $('.URstage2Inter').show();
        $('.iconsUR').removeClass('fa-plus-circle');
        $('.iconsUR').addClass('fa-minus-circle');
      }
      if (this.interactionBFToggleStatus == false) {
        $('.BFstage2Inter').hide();
        $('.iconsBF').removeClass('fa-minus-circle');
        $('.iconsBF').addClass('fa-plus-circle');
      } else {
        $('.BFstage2Inter').show();
        $('.iconsBF').removeClass('fa-plus-circle');
        $('.iconsBF').addClass('fa-minus-circle');
      }
      if (this.interactionXXToggleStatus == false) {
        $('.XXstage2Inter').hide();
        $('.iconsXX').removeClass('fa-minus-circle');
        $('.iconsXX').addClass('fa-plus-circle');
      } else {
        $('.BFstage2Inter').show();
        $('.iconsXX').removeClass('fa-plus-circle');
        $('.iconsXX').addClass('fa-minus-circle');
      }
    } else if (mapper == 'Scope') {
      this.TFToggleStatus = false;
      this.URToggleStatus = false;
      this.BFToggleStatus = false;
      this.XXToggleStatus = false;
      this.interactionTFToggleStatus = false;
      this.interactionURToggleStatus = false;
      this.interactionBFToggleStatus = false;
      this.interactionXXToggleStatus = false;
      this.scopeTFToggleStatus = TF;
      this.scopeURToggleStatus = UR;
      this.scopeBFToggleStatus = BF;
      this.scopeXXToggleStatus = BF;
      if (this.scopeTFToggleStatus == false) {
        $('.TFstage2Scope').hide();
        $('.iconsTF').removeClass('fa-minus-circle');
        $('.iconsTF').addClass('fa-plus-circle');
      } else {
        $('.TFstage2Scope').show();
        $('.iconsTF').removeClass('fa-plus-circle');
        $('.iconsTF').addClass('fa-minus-circle');
      }
      if (this.scopeURToggleStatus == false) {
        $('.URstage2Scope').hide();
        $('.iconsUR').removeClass('fa-minus-circle');
        $('.iconsUR').addClass('fa-plus-circle');
      } else {
        $('.URstage2Scope').show();
        $('.iconsUR').removeClass('fa-plus-circle');
        $('.iconsUR').addClass('fa-minus-circle');
      }
      if (this.scopeBFToggleStatus == false) {
        $('.BFstage2Scope').hide();
        $('.iconsBF').removeClass('fa-minus-circle');
        $('.iconsBF').addClass('fa-plus-circle');
      } else {
        $('.BFstage2Scope').show();
        $('.iconsBF').removeClass('fa-plus-circle');
        $('.iconsBF').addClass('fa-minus-circle');
      }
      if (this.scopeXXToggleStatus == false) {
        $('.XXstage2Scope').hide();
        $('.iconsXX').removeClass('fa-minus-circle');
        $('.iconsXX').addClass('fa-plus-circle');
      } else {
        $('.XXstage2Scope').show();
        $('.iconsXX').removeClass('fa-plus-circle');
        $('.iconsXX').addClass('fa-minus-circle');
      }
    }
  }
  // code fn open

  resetMenu() {
    this.menu = {
      show: false,
      project: {
        show: false,
        new: {
          show: false,
        },
        list: {
          show: false,
        },
        clone: {
          show: false,
        },
        modify: {
          show: false,
        },
        delete: {
          show: false,
        },
      },
      session: {
        show: false,
      },
      theme: {
        show: false,
      },
      report: {
        show: false,
        systeminfo: {
          show: false,
        },
        scenarios: {
          show: false,
        },
        suites: {
          show: false,
        },
      },
      orgmgmt: {
        show: false,
        orglist: {
          show: false,
        },
        orgadd: {
          show: false,
        },
        orgdelete: {
          show: false,
        },
      },
      language: {
        show: false,
      },
      logout: {
        show: false,
      },
    };
  }
  // function to remove user from acive project list
  removeActiveProject() {
    let userID = this.myUserID;
    let activeProjectID = localStorage.getItem('projectID');
    if (activeProjectID == null) {
      activeProjectID = this.oldProjectID;
    }

    this.ProjectServices.removeActiveProject({ userId: userID }).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.socket.emit(
            'projectSession',
            JSON.stringify({ projectId: activeProjectID, userId: userID })
          );
        } else {
          this.triggerToast(this.appService.getResourceText('B002'));
        }
      }
    );
  }

  // function to get messages from all users
  // new notification will get from server using sockets
  getAllMessages() {
    var projectID = localStorage.getItem('projectID');
    this.socket.on('notify', (response: any) => {
      // console.log("ress", response);
      if (response.statusCode == 201) {
        if (localStorage.getItem('sessionID') != undefined) {
          this.notificationsComponent.getNotifications();
        }
        this.triggerToastUser(this.appService.getResourceText('B031'));
      } else {
        // this.triggerToastUser(this.appService.getResourceText('B031'));
      }
    });
    this.socket.on(this.myUserID + this.mySocketID, (res: any) => {
      // console.log("received message", res);
      if (this.chatUpdateColor == false && this.chatPopupOpened == false) {
        this.chatUpdateColor = true;
      }
      this.chatMessages.push(res);
    });
    // console.log('this.chatMessages', this.chatMessages);
  }

  // To reset chat icon color to default
  openChatPopup() {
    this.chatUpdateColor = false;
    if (this.chatPopupOpened == true) {
      this.chatPopupOpened = false;
    } else {
      this.chatPopupOpened = true;
    }
  }

  // function to update user from acive project list
  updateActiveProject() {
    this.ProjectServices.updateActiveProject(this.activeProject).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.socket.emit(
            'projectSession',
            JSON.stringify(this.activeProject)
          );
        }
        //// error res code
        // triggerToast(AppService.getResourceText("B002"));
      }
    );
  }

  // this function is using to generate a unique id with 16-char string
  uniqueEID() {
    var model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
    );
  }

  // Function to close a Popover by clicking anywhere in window
  // $(document).on('click', function (e) {
  //   $('[data-toggle="popover"],[data-original-title]').each(function () {
  //     //the 'is' for buttons that trigger popups
  //     //the 'has' for icons within a button that triggers a popup
  //     if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
  //       (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false  // fix for BS 3.3.6
  //     }
  //   });
  // });

  resetProjectMenu() {
    if (this.selectedProject) {
      // this.selectedProject = this.projects[0] || {};
      this.selectedProject = {};
    }
  }

  modalHideOnSuccess() {
    $('#hamburgerMenu').modal('hide');
  }

  loadProjectMenu(application: any) {
    this.resetProjectMenu();
    this.projects = [];
    this.projectsLoaded = false;
    this.templates = [];
    this.templateNames = [];


    this.ProjectServices.loadProjects(this.selectedApplication).subscribe((response: any) => {
      if (response.statusCode === 200) {
        this.projectsLoaded = true;
        this.projects = response.record;
        // .sort((a: any, b: any) =>
        //   a.projectDetails.name.localeCompare(b.projectDetails.name)
        // );
        this.projectsMgmtList = this.projects;
        this.projectsMgmtList = $.grep(this.projectsMgmtList, (e: any) => {
          return e.projectDetails.name != 'Demo app';
        });

        this.currProject = this.projects[0] || { projectDetails: { name: '', description: '' }, jiraProjectDetails: { name: '', id: '', url: '', key: '' } };
        this.selectedProject = this.projects[0] || {};
        this.modelDataCopy = JSON.stringify(this.projects[0] || {});
        // console.log("this.projects", this.projects);
        // console.log("this.currProject", this.currProject);
        // console.log("this.oldProjectID", this.oldProjectID);
        this.manageSelectedProject(this.currProject);
        if (this.oldProjectID == null || this.oldProjectID == undefined) {
          this.setCurrentProject(this.currProject);
          // console.log("curr",this.currProject);
          this.manageSelectedProject(this.currProject);
        } else {
          // console.log("this.projects", this.projects);
          // console.log("this.oldProjectID", this.oldProjectID);
          var cProject = this.projects.find(
            (project: any) => project._id == this.oldProjectID
          );
          // console.log("cProject",this.currProject);
          this.setCurrentProject(cProject);
          // console.log("c",cProject);
          this.manageSelectedProject(cProject);
        }
        this.loadTemplates();
        //this.newProject = this.projects[0] || {};
        this.getOrgUsers();
        // this.getProjectUsers(this.currProject);
        if (this.projects.length == 0) {
          this.isPrjMrmtDisabled = true;
        }
      }
    });

    if (this.selectedProject) {
      this.selectedProject = this.projects[0] || {};
    }
    this.newProject = Object.assign(
      {},
      {
        checklists: [],
        cockpit: {
          //tasks+
          functionalScenarioCount: 0,
          functionalScenarioPostiveCount: 0,
          functionalScenarioNegativeCount: 0,
          nonFunctionalScenarioCount: 0,
          nonFunctionalScenarioPostiveCount: 0,
          nonFunctionalScenarioNegativeCount: 0,
          //readyness
          readyEUTStatus: 0,
          scenarioTFStatus: 0,
          scenarioBFStatus: 0,
          scenarioURStatus: 0,
          scenarioXXStatus: 0,
          scenarioTF: 0,
          scenarioBF: 0,
          scenarioUR: 0,
          scenarioXX: 0,
          Attributestatus: 0,
          //evaluvated
          EUTEvaluationStatus: 0,
          EUTEvaluationCount: 0,
          scenarioExecTFStatus: 0,
          scenarioExecTF: 0,
          scenarioExecBFStatus: 0,
          scenarioExecBF: 0,
          scenarioExecURStatus: 0,
          scenarioExecUR: 0,
          scenarioExecXXStatus: 0,
          scenarioExecXX: 0,
          AttributeEvaluationStatus: 0,
          AttributeEvaluationCount: 0,
          //outcomes
          EUTCleanStatus: 0,
          cleanEUTOutcome: 0,
          EUTCleanTFStatus: 0,
          cleanEUTTFOutcome: 0,
          EUTCleanBFStatus: 0,
          cleanEUTBFOutcome: 0,
          EUTCleanURStatus: 0,
          cleanEUTUROutcome: 0,
          EUTCleanXXStatus: 0,
          cleanEUTXXOutcome: 0,
          AttriCleanStatus: 0,
          cleanAttriOutcome: 0,
        },
        projectDetails: {
          name: '',
          description: '',
          noOfSession: 0,
          session: 0,
          tasks: [],
          sprintTasks: [],
          // jiraBugs: [],
          sprintEUTs: [],
          details: undefined,
          templateName: undefined,
          createdBy: this.userName,
          lastModifiedBy: this.userName,
        },
      }
    );
    // $window.scrollTo(0, 0);
  }

  setCurrentProject(currProject: any) {
    if (currProject.projectDetails) {
      this.currProjectName = currProject.projectDetails.name;
      localStorage.setItem('projectName', currProject.projectDetails.name);
    }
    this.currProject = currProject;
    localStorage.setItem('projectID', currProject._id);
    localStorage.setItem('applicationID', currProject.applicationId);
  }

  loadTemplates() {
    this.ProjectServices.loadTemplates().subscribe((response: any) => {
      if (response.status === 200) {
        this.templates = response;
        this.templateNames = response.map((template: any) => template.name);
        this.currSession = 'RECON';
        this.optradio = 'new';
        this.importCheck = false;
        this.disableLinks = this.projects.length ? true : false;
        this.projectOpen = false;
      }
    });
  }

  refreshProject(application: any) {
    this.ProjectServices.loadProjects(application).subscribe((response: any) => {
      this.projects = response.record;
      // this.projects.sort((a: any, b: any) =>
      //   a.projectDetails.name.localeCompare(b.projectDetails.name)
      // );
      // this.projects = this.projects.sort((a: any, b: any) =>
      //   a.projectDetails.name < b.projectDetails.name ? -1 : 1
      // );

      this.projects.sort((a: any, b: any) => {
        a.projectDetails.name.localeCompare(b.projectDetails.name);
      });
      this.currProject = this.projects[0] || { projectDetails: { name: '', description: '' }, jiraProjectDetails: { name: '', id: '', url: '', key: '' } };
      this.selectedProject = this.projects[0] || {};
      this.optradio = 'new';
      this.importCheck = false;
      this.disableLinks = this.projects.length ? true : false;
      this.manageSelectedProject(this.currProject);
    });
  }

  //opening the project menu which has three layers
  showMenu(level1: any, level2: any, level3: any) {
    this.resetProjectMenu();
    this.resetMenu();
    if (level1) {
      this.menu.show = true;
    }
    if (level2) {
      this.menu[level2].show = true;
    }
    if (level3) {
      this.menu[level2][level3].show = true;
    }
  }

  switchProject() {
    this.projectOpen = false;
    this.readmode(true);
    this.updateActiveProject();
    let publicToken: any = localStorage.getItem('publicToken');
    let userName: any = localStorage.getItem('userName');
    let userID: any = localStorage.getItem('userID');
    let loginDetails: any = localStorage.getItem('loginDetails');
    localStorage.clear();
    localStorage.setItem('publicToken', publicToken);
    localStorage.setItem('userName', userName);
    localStorage.setItem('userID', userID);
    localStorage.setItem('loginDetails', loginDetails);
    $('#switchProjectConfirm').modal('hide');
    this.jiraLogin = { username: '', password: '', jiraurl: '' };
    this.openTool('projectSelect');
    window.location.reload();
  }

  //function for clicking on the various options in the project menu and initialising the project details

  openMenu(type: any) {
    switch (type) {
      case 'menu':
        this.refreshProject(this.selectedApplication);
        this.showMenu('menu', '', '');
        break;
      case 'project':
        this.showMenu('menu', 'project', '');
        break;
      case 'delete':
        this.showMenu('menu', 'project', 'delete');
        break;
      case 'theme':
        this.showMenu('menu', 'theme', '');
        break;
      // case 'download':
      //   this.entityTypeScenario = [];
      //   this.showMenu('menu', '', '');
      //   break;
      case 'switch':
        this.switchProject();

        break;
      case 'orgmgmt':
        this.showMenu('menu', 'orgmgmt', '');
        break;
      case 'report':
        this.showMenu('menu', 'report', '');
        break;
      case 'language':
        this.showMenu('menu', 'language', '');
        break;
      case 'feedback':
        this.showMenu('menu', 'feedback', '');
        break;
      case 'projectmgmt':
        this.showMenu('menu', '', '');
        this.clickFirstRow();
        break;
      case 'jiralogin':
        this.showMenu('menu', '', '');
        break;
    }
  }

  clickFirstRow() {
    $('#myProjectsMgmtTable tr:first-child').trigger('click');
  }

  manageSelectedProject(currProject: any) {
    this.currProject = currProject;
    this.getOrgProjectUsers(currProject);
    this.getProjectUsers(currProject);
    this.getOrgUsersByProjectOrgID(currProject);
    this.currProjectInPrjMgmt = currProject.projectDetails.name;
  }

  manageSelectedProjectFromDL(projectName: any) {
    for (let p = 0; p < this.projects.length; p++) {
      if (projectName === this.projects[p].projectDetails.name) {
        this.currProject = this.projects[p];
        localStorage.setItem(
          'projectName',
          this.projects[p].projectDetails.name
        );
        localStorage.setItem('projectID', this.projects[p]._id);
        localStorage.setItem('applicationID', this.projects[p].applicationId);
        this.getOrgProjectUsers(this.projects[p]);
        this.getProjectUsers(this.projects[p]);
        this.currProjectInPrjMgmt = this.projects[p].projectDetails.name;
      }
    }
  }

  exportJSON() {
    let usersObj = {
      applicationID: this.currProject.applicationId,
      users: this.projectUserListIds,
      deleteusers: this.delProUsers,
      projectDetails: this.currProject.projectDetails,
    };

    this.userManagementService
      .updateUsersFromApplication(usersObj)
      .subscribe((response: any) => {
        if (response.statusCode == 200 || response.statusCode == 201) {
          this.ProjectServices.getProject(this.currProject._id).subscribe(
            (response: any) => {
              // console.log('params', response);
              if (response.statusCode == 200) {
                var data = response.record;
                var filename = this.currProject.projectDetails.name + '.json';
                if (!data) {
                  console.error('No data');
                  return;
                }
                if (!filename) filename = 'console.json';

                if (typeof data === 'object') {
                  data = JSON.stringify(data, undefined, 4);
                }

                var blob = new Blob([data], { type: 'text/json' }),
                  e = document.createEvent('MouseEvents'),
                  a = document.createElement('a');

                a.download = filename;
                a.href = window.URL.createObjectURL(blob);
                a.dataset.downloadurl = ['text/json', a.download, a.href].join(
                  ':'
                );
                e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
              } else {
              }
            }
          );
        } else {
        }
      });
  }

  triggerToastUser(message: any) {
    this.toastMsgUserStatus = message;
    $('#userStatusToast').html(message);
    var x: any = document.getElementById('userStatusToast');
    x.className = 'show';
    setTimeout(() => {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  endSession() {
    if (this.project && this.project.open) {
      this.project.endSession();
      this.ProjectServices.updateProject(this.project.model, true);
    }
  }

  autosave() {
    // console.log('log1');
    if (this.projectOpen) {

      if (this.currentActiveUsersCount >= 1) {

        this.socket.on(this.modelData._id, (updatedModelBit: any, updatedModelJSON: any) => {

          if (JSON.stringify(this.modelData) != updatedModelJSON) {
            var syncModelData = JSON.parse(updatedModelBit);
            // console.log('syncModelData', syncModelData);
            if (syncModelData.type == 'PERSONA') {
              this.syncPersonaModelChanges(syncModelData);
            } else if (syncModelData.type == 'MODULE') {
              this.syncModuleModelChanges(syncModelData);
            } else if (syncModelData.type == 'ENTITY') {
              this.syncEntityModelChanges(syncModelData);
            } else if (syncModelData.type == 'ENVIRONMENT') {
              this.syncEnvironmentModelChanges(syncModelData);
            } else if (syncModelData.type == 'ATTRIBUTE') {
              this.syncAttributeModelChanges(syncModelData);
            } else if (syncModelData.type == 'SPECS') {
              this.syncSpecsModelChanges(syncModelData);
            } else if (syncModelData.type == 'NOTES') {
              this.syncNotesModelChanges(syncModelData);
            } else if (syncModelData.type == 'TASK') {
              this.syncTaskModelChanges(syncModelData);
            } else if (syncModelData.type == 'PMAP') {
              this.syncPmapModelChanges(syncModelData);
            } else if (syncModelData.type == 'IMAP') {
              this.syncImapModelChanges(syncModelData);
            } else if (syncModelData.type == 'SMAP') {
              this.syncSmapModelChanges(syncModelData);
            } else if (syncModelData.type == 'EMAP') {
              this.syncEmapModelChanges(syncModelData);
            } else if (syncModelData.type == 'PLANNER') {
              this.syncPlannerModelChanges(syncModelData);
            } else if (syncModelData.type == 'SCENARIO') {
              this.syncScenarioModelChanges(syncModelData);
            } else if (syncModelData.type == 'RUNINFO') {
              this.syncRuninfoModelChanges(syncModelData);
            } else if (syncModelData.type == 'CHECKLIST') {
              this.syncChecklistModelChanges(syncModelData);
            } else if (syncModelData.type == 'SUITE') {
              this.syncSuiteModelChanges(syncModelData);
            }

            //new data sync code
            // var modalDataCopy = JSON.parse(this.modelDataCopy);
            // var SenderModalData = JSON.parse(updatedModelJSON);
            // this.getModuleDifference(SenderModalData.modules, this.modelData.modules, modalDataCopy.modules);
            // this.getPersonaDifference(SenderModalData.persona, this.modelData.persona, modalDataCopy.persona);
            // this.getEUTDifference(SenderModalData.listOfEUTs, this.modelData.listOfEUTs, modalDataCopy.listOfEUTs);
            // this.getTasksDifference(SenderModalData.tasks, this.modelData.tasks, modalDataCopy.tasks);
            // this.getEnvDifference(SenderModalData.listOfEnv, this.modelData.listOfEnv, modalDataCopy.listOfEnv);
            // this.getPMapDifference(SenderModalData.personaMap, this.modelData.personaMap, modalDataCopy.personaMap);
            // this.getIMapDifference(SenderModalData.interactionMap, this.modelData.interactionMap, modalDataCopy.interactionMap);
            // this.getSMapDifference(SenderModalData.scopeMap, this.modelData.scopeMap, modalDataCopy.scopeMap);
            // this.getEMapDifference(SenderModalData.envMap, this.modelData.envMap, modalDataCopy.envMap);
            // this.getScenarioDifference(SenderModalData.scenarios, this.modelData.scenarios, modalDataCopy.scenarios);
            // this.getEUTdetDifference(SenderModalData.EUTdetails, this.modelData.EUTdetails, modalDataCopy.EUTdetails);
            // this.getEUTNoteDifference(SenderModalData.myNotes, this.modelData.myNotes, modalDataCopy.myNotes);
            // this.getSuiteDifference(SenderModalData.suites, this.modelData.suites, modalDataCopy.suites);
            // this.getRunIDifference(SenderModalData.runInfo, this.modelData.runInfo, modalDataCopy.runInfo);
          }
        });
      } else {

        // return;
        // if (this.modelDataCopy != JSON.stringify(this.modelData)) {
        // console.log('modalupdate log');
        this._sharedService.updateProject(this.modelData);
        this.modelDataCopy = JSON.stringify(this.modelData);
        // }
      }
    }



    // Network connection check
    if (navigator.onLine) {
      // console.log('online');
      this.networkConnection = true;
    } else {
      // console.log('offline');
      this.networkConnection = false;
    }
  }

  // Emit updated model data to other active users
  updateActiveUsersModel(data: any) {
    // console.log("data", data);
    if (this.modelDataCopy != JSON.stringify(this.modelData)) {
      this.modelDataCopy = JSON.stringify(this.modelData);
      this.socket.emit('modelUpdate', this.modelData._id, JSON.stringify(data), JSON.stringify(this.modelData));
      this._sharedService.updateProject(this.modelData);
    }

  }

  //sync with other users personas
  syncPersonaModelChanges(syncData: any) {
    // console.log("syncData Persona",syncData);
    if (syncData.operation == 'CREATE') {
      var personaFound = this.modelData.persona.find(
        (item: any) => item.pName == syncData.data.pName
      );
      if (!personaFound) {
        return this.modelData.persona.unshift(syncData.data);
      }
      // console.log("Persona",this.modelData.persona);
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.persona.length; i++) {
        if (this.modelData.persona[i].pType == syncData.data.pType) {
          return this.modelData.persona[i].pName = syncData.data.pName
        }
      }
    } else if (syncData.operation == 'DELETE') {
      for (var i = 0; i < this.modelData.persona.length; i++) {
        if (this.modelData.persona[i].pType == syncData.data.pType) {
          return this.modelData.persona.splice(i, 1);
        }
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }

  //sync with other users modules
  syncModuleModelChanges(syncData: any) {
    // console.log("syncData Module",syncData);
    if (syncData.operation == 'CREATE') {
      var moduleFound = this.modelData.modules.find(
        (item: any) => item.mName == syncData.data.mName
      );
      if (!moduleFound) {
        return this.modelData.modules.unshift(syncData.data);
      }
      // console.log("Module",this.modelData.modules);
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.modules.length; i++) {
        if (this.modelData.modules[i].mID == syncData.data.mID) {
          return this.modelData.modules[i].mName = syncData.data.mName
        }
      }
    } else if (syncData.operation == 'DELETE') {
      for (var i = 0; i < this.modelData.modules.length; i++) {
        if (this.modelData.modules[i].mID == syncData.data.mID) {
          return this.modelData.modules.splice(i, 1);
        }
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }

  //sync with other users modules
  syncEntityModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      var eutFound = this.modelData.listOfEUTs.find(
        (item: any) => (item.eName.toLowerCase() == syncData.data.eName.toLowerCase() && item.mID == syncData.data.mID)
      );
      if (!eutFound) {
        return this.modelData.listOfEUTs.unshift(syncData.data);
      }
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
        if (this.modelData.listOfEUTs[i].eID == syncData.data.eID) {
          this.modelData.listOfEUTs[i].eType = syncData.data.eType
          this.modelData.listOfEUTs[i].eName = syncData.data.eName
          this.modelData.listOfEUTs[i].base_eID = syncData.data.base_eID
          return;
        }
      }
    } else if (syncData.operation == 'DELETE') {
      for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
        if (this.modelData.listOfEUTs[j].eID == syncData.data) {
          this.deleteTasksByeutID(syncData.data, this.modelData.listOfEUTs[j]);
          this.modelData.listOfEUTs.splice(j, 1);
          j--;
        }
      }
    }

    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteTasksByeutID(eID: any, log: any) {
    for (var k = 0; k < this.modelData.tasks.length; k++) {
      if (this.modelData.tasks[k].entity_Id == eID) {
        this.modelData.tasks.splice(k, 1);
        k--;
      }
    }
    for (var n = 0; n < this.modelData.tasks.length; n++) {
      if (this.modelData.tasks[n].primaryentity_Id != "") {
        if (this.modelData.tasks[n].primaryentity_Id == eID) {
          this.modelData.tasks.splice(n, 1);
          n--;
        }
      }
    }

    for (var l = 0; l < this.modelData.EUTdetails.length; l++) {
      if (this.modelData.EUTdetails[l].eID == eID) {
        this.modelData.EUTdetails.splice(l, 1);
        l--;
      }
    }
    for (var o = 0; o < this.modelData.scenarios.length; o++) {
      if (this.modelData.scenarios[o].eID == eID) {
        this.modelData.scenarios.splice(o, 1);
        o--;
      }
    }
    for (var m = 0; m < this.modelData.interactionMap.length; m++) {
      if (this.modelData.interactionMap[m].eut2 == eID || this.modelData.interactionMap[m].eut1 == eID) {
        this.modelData.interactionMap.splice(m, 1);
        m--;
      }
    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
    return;
  }
  //sync with other users environment
  syncEnvironmentModelChanges(syncData: any) {
    // console.log("syncData Env", syncData);
    if (syncData.operation == 'CREATE') {
      var envFound = this.modelData.listOfEnv.find(
        (item: any) => item.envType.toLowerCase() == syncData.data.envType.toLowerCase()
      );
      if (!envFound) {
        return this.modelData.listOfEnv.unshift(syncData.data);
      }
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.listOfEnv.length; i++) {
        if (this.modelData.listOfEnv[i].envID == syncData.data.envID) {
          this.modelData.listOfEnv[i]['envType'] = syncData.data.envType
          this.modelData.listOfEnv[i]['envValues'] = syncData.data.envValues
          return;
        }
      }
    } else if (syncData.operation == 'DELETE') {
      for (var j = 0; j < this.modelData.listOfEnv.length; j++) {
        if (this.modelData.listOfEnv[j].envType == syncData.data.envType) {
          return this.modelData.listOfEnv.splice(j, 1);
        }
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }

  //sync with other users attributes
  syncAttributeModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      syncData.data['description'] = syncData.desc;
      this.modelData.listOfAttributes.push(syncData.data);
    } else if (syncData.operation == 'UPDATE') {
      var index = this.modelData.listOfAttributes.findIndex((attr: any) => attr.symbol == syncData.data.symbol)
      if (index >= 0) {
        this.modelData.listOfAttributes[index]['description'] = syncData.desc;
      }
    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }

  //sync with other users specs
  syncSpecsModelChanges(syncData: any) {
    if (syncData.operation == 'UPDATE') {
      // for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      this.modelData.EUTdetails.forEach(function (obj: any) {
        if (obj.eID == syncData.data.eID) {
          if (syncData.detail == "ac") {
            obj.ac = syncData.data.ac;
          }
          if (syncData.detail == "bc") {
            obj.bc = syncData.data.bc;
          }
          if (syncData.detail == "oc") {
            obj.outcomes = syncData.data.outcomes;
          }
          if (syncData.detail == "pi") {
            obj.pIssues = syncData.data.pIssues;
          }
          obj.bDescription = syncData.data.bDescription;
          return;
        }
      });
    } else if (syncData.operation == 'ADD') {
      var entityDetailsExists = this.modelData.EUTdetails.find(
        (test: any) => test.eID == syncData.data.eID
      );
      if (!entityDetailsExists) {
        this.modelData.EUTdetails.push({
          eID: syncData.data.eID,
          bc: '',
          ac: '',
          outcomes: '',
          bDescription: '',
          pIssues: '',
          notes: this.Config.entityDefaultNotes
        });
      }
      
    } else if (syncData.operation == "TESTTYPEDescAdd") {
      for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
        if (this.modelData.EUTdetails[i].eID == syncData.eut.eID) {
          if (this.modelData.EUTdetails[i].testTypes) {
            var Testtypeexists = this.modelData.EUTdetails[i].testTypes.find(
              (test: any) => test.symbol == syncData.data.symbol
            );
            if (Testtypeexists) {
              syncData.data = Testtypeexists;
            } else {
              this.modelData.EUTdetails[i].testTypes.push(syncData.data);
            }
            return;
          } else {
            this.modelData.EUTdetails[i]['testTypes'] = [syncData.data];
            return;
          }
        }
      }
    } else if (syncData.operation == "TESTTYPEDescUpdate") {
      for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
        if (this.modelData.EUTdetails[i].eID == syncData.eut.eID) {
          for (var j = 0; j < this.modelData.EUTdetails[i].testTypes.length; j++) {
            if (this.modelData.EUTdetails[i].testTypes[j].symbol == syncData.data.symbol) {
              this.modelData.EUTdetails[i].testTypes[j].desc = syncData.data.desc;
              return;
            }
          }
        }
      };
    } else if (syncData.operation == "TESTTYPEDescDelete") {
      for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
        if (this.modelData.EUTdetails[i].eID == syncData.eut.eID) {
          for (var j = 0; j < this.modelData.EUTdetails[i].testTypes.length; j++) {
            if (this.modelData.EUTdetails[i].testTypes[j].symbol == syncData.data) {
              this.modelData.EUTdetails[i].testTypes.splice(j, 1);
              return;
            }
          }
        }
      };
    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
    this._sharedService.triggerActiveItem(syncData);
  }

  //sync with other users notes
  syncNotesModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      return this.modelData.myNotes.push(syncData.data);
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.myNotes.length; i++) {
        if (this.modelData.myNotes[i].eID == syncData.data.eID) {
          this.modelData.myNotes[i]['eID'] = syncData.data.eID;
          this.modelData.myNotes[i]['notes'] = syncData.notes;
        }
      }
    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  //sync with other users Persona Mapper
  syncPmapModelChanges(syncData: any) {
    // console.log("syncData",syncData);
    if (syncData.operation == 'CREATE') {
      var pMapFound = this.modelData.personaMap.find(
        (item: any) => (item.eID == syncData.data.eID && item.pType == syncData.data.pType)
      );
      if (!pMapFound) {
        this.modelData.personaMap.unshift(syncData.data);
        return;
      }
    } else if (syncData.operation == 'DELETE') {
      // console.log("syncData",syncData.data);
      var index = this.modelData.personaMap.findIndex((map: any) => map.pType == syncData.data.pType && map.eID == syncData.data.eID);
      if (index > -1) {
        this.modelData.personaMap.splice(index, 1);
        return;
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
    this._sharedService.triggerActiveItem(syncData);
  }

  //sync with other users Interaction Mapper
  syncImapModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      var iMapFound = this.modelData.interactionMap.find(
        (item: any) => (item.eut1 == syncData.data.eut1 && item.eut2 == syncData.data.eut2)
      );
      if (!iMapFound) {
        this.modelData.interactionMap.unshift(syncData.data);
        return;
      }
    } else if (syncData.operation == 'DELETE') {
      var index = this.modelData.interactionMap.findIndex((map: any) => map.eut1 == syncData.data.eut1 && map.eut2 == syncData.data.eut2);
      if (index > -1) {
        this.modelData.interactionMap.splice(index, 1);
        return;
      }
    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
    this._sharedService.triggerActiveItem(syncData);
  }

  //sync with other users Scope Mapper
  syncSmapModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      var iMapFound = this.modelData.scopeMap.find(
        (item: any) => (item.aType == syncData.data.aType && item.eID == syncData.data.eID)
      );
      if (!iMapFound) {
        this.modelData.scopeMap.unshift(syncData.data);
        return;
      }
    } else if (syncData.operation == 'DELETE') {
      var index = this.modelData.scopeMap.findIndex((map: any) => map.aType == syncData.data.aType && map.eID == syncData.data.eID);
      if (index > -1) {
        this.modelData.scopeMap.splice(index, 1);
        return;
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
    this._sharedService.triggerActiveItem(syncData);
  }
  //sync with other users Environment Mapper
  syncEmapModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      var eMapFound = this.modelData.envMap.find(
        (item: any) => (item.envName.toUpperCase() == syncData.data.envName.toUpperCase())
      );
      if (!eMapFound) {
        this.modelData.envMap.unshift(syncData.data);
        return;
      }
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.envMap.length; i++) {
        if (this.modelData.envMap[i].envId == syncData.data.envId) {
          this.modelData.envMap[i]['envList'] = syncData.data.envList;
          this.modelData.envMap[i]['envName'] = syncData.data.envName;
          this.modelData.envMap[i]['envTypes'] = syncData.data.envTypes;
        }
        return;
      }

    } else if (syncData.operation == 'DELETE') {
      var index = this.modelData.envMap.findIndex((map: any) => map.envId == syncData.data.envId);
      if (index > -1) {
        this.modelData.envMap.splice(index, 1);
        return;
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }

  //sync with other users Planner
  syncPlannerModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      // var taskFound = this.modelData.tasks.find(
      //   (item: any) => (item.envName.toUpperCase() == syncData.data.envName.toUpperCase())
      // );
      // if (!taskFound) {
      this.modelData.tasks.unshift(syncData.data);
      return;
      // }
    } else if (syncData.operation == 'UPDATE') {
      // for (var i = 0; i < this.modelData.envMap.length; i++) {
      //   if (this.modelData.envMap[i].envId == syncData.data.envId) {
      //     this.modelData.envMap[i]['envList'] = syncData.data.envList;
      //     this.modelData.envMap[i]['envName'] = syncData.data.envName;
      //     this.modelData.envMap[i]['envTypes'] = syncData.data.envTypes;
      //   }
      //   return;
      // }

    } else if (syncData.operation == 'DELETE') {
      for (let j = 0; j < this.modelData.tasks.length; j++) {
        if (
          this.modelData.tasks[j].task_combine_id == syncData.data
        ) {
          this.modelData.tasks.splice(j, 1);
          return;
        }
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
    this._sharedService.triggerActiveItem(syncData);
  }

  //sync with other users personas
  syncTaskModelChanges(syncData: any) {
    // console.log("syncData", syncData);
    if (syncData.operation == 'CREATE') {
      var taskFound = this.modelData.tasks.find(
        (item: any) => item.taskId == syncData.data.taskId
      );
      if (!taskFound) {
        return this.modelData.tasks.unshift(syncData.data);
      }
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.persona.length; i++) {
        if (this.modelData.persona[i].pType == syncData.data.pType) {
          return this.modelData.persona[i].pName = syncData.data.pName
        }
      }
    } else if (syncData.operation == 'DELETE') {
      for (var i = 0; i < this.modelData.tasks.length; i++) {
        if (this.modelData.tasks[i].task_combine_id == syncData.data.task_combine_id) {
          return this.modelData.tasks.splice(i, 1);
        }
      }
    } else if (syncData.operation == 'INTERACT') {
      var index = this.modelData.tasks.findIndex((map: any) => map.entity_Id == syncData.data.entity_Id && map.primaryentity_Id == syncData.data.primaryentity_Id && map.toolType == 'ex');
      if (index > -1) {
        this.modelData.tasks.splice(index, 1);
        return;
      }
    } else if (syncData.operation == 'SCOPE') {
      for (var i = 0; i < this.modelData.tasks.length; i++) {
        if (this.modelData.tasks[i].toolType == 'de' || this.modelData.tasks[i].toolType == 'ex') {
          if (this.modelData.tasks[i].entity_Id == syncData.data.eID && this.modelData.tasks[i].attribute.symbol == syncData.data.aType) {
            this.modelData.tasks.splice(i, 1);
            i--;
          }
        }
      }
    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }

  //sync with other users checklist
  syncChecklistModelChanges(syncData: any) {
    // console.log(syncData);
    if (syncData.operation == 'CREATE') {
      var checklistFound = this.modelData.checklists.find(
        (item: any) => item.checklistName == syncData.data.checklistName
      );
      if (!checklistFound) {
        return this.modelData.checklists.unshift(syncData.data);
      }
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.checklists.length; i++) {
        if (this.modelData.checklists[i].checklistId == syncData.data.checklistId) {
          return this.modelData.checklists[i].checklistName = syncData.name
        }
      }
    } else if (syncData.operation == 'DELETE') {
      // console.log("delete from model", syncData.data);
      for (var i = 0; i < this.modelData.checklists.length; i++) {
        if (this.modelData.checklists[i].checklistId == syncData.data.checklistId) {
          return this.modelData.checklists.splice(i, 1);
        }
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }

  //sync with other users scenarios
  syncScenarioModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      var scenarioFound = this.modelData.scenarios.find(
        (item: any) => (item.description.toLowerCase() == syncData.data.description.toLowerCase() && item.tID == syncData.data.tID && item.eID == syncData.data.eID)
      );
      if (!scenarioFound) {
        return this.modelData.scenarios.unshift(syncData.data);
      }
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.scenarios.length; i++) {
        if (this.modelData.scenarios[i].scenID == syncData.data.scenID) {
          this.modelData.scenarios[i].tID = syncData.data.tID;
          this.modelData.scenarios[i].attribute = syncData.data.attribute;
          this.modelData.scenarios[i].cr = syncData.data.cr;
          this.modelData.scenarios[i].priority = syncData.data.priority;
          this.modelData.scenarios[i].description = syncData.data.description;
          return;
        }
      }
    } else if (syncData.operation == 'DELETE') {
      for (var i = 0; i < this.modelData.scenarios.length; i++) {
        if (this.modelData.scenarios[i].scenID == syncData.data.scenID) {
          return this.modelData.scenarios.splice(i, 1);
        }
      }

    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }



  //sync with other users Run info
  syncRuninfoModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      var infoFound = this.modelData.runInfo.find(
        (item: any) => (item.scenID == syncData.data.scenID && item.buildID == syncData.data.buildID)
      );
      if (!infoFound) {
        this.modelData.runInfo.unshift(syncData.data);
        return;
      }
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.runInfo.length; i++) {
        if (
          this.modelData.runInfo[i].scenID == syncData.data.scenID &&
          this.modelData.runInfo[i].buildID == syncData.data.buildID
        ) {
          this.modelData.runInfo[i].status = syncData.data.status;
          return;
        }
      }
    } else if (syncData.operation == 'UPDATEO') {
      for (var i = 0; i < this.modelData.runInfo.length; i++) {
        if (
          this.modelData.runInfo[i].scenID == syncData.data.scenID &&
          this.modelData.runInfo[i].buildID == syncData.data.buildID
        ) {
          this.modelData.runInfo[i].outcome = syncData.data.outcome;
          return;
        }
      }
    } else if (syncData.operation == 'DELETE') {
      // var index = this.modelData.scopeMap.findIndex((map: any) => map.aType == syncData.data.aType && map.eID == syncData.data.eID);
      // if (index > -1) {
      //   this.modelData.scopeMap.splice(index, 1);
      //   return;
      // }
    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }


  //sync with other users suites
  syncSuiteModelChanges(syncData: any) {
    if (syncData.operation == 'CREATE') {
      var suiteFound = this.modelData.suites.find(
        (item: any) => item.suiteName.toUpperCase() == syncData.data.suiteName.toUpperCase()
      );
      if (!suiteFound) {
        return this.modelData.suites.unshift(syncData.data);
      }
    } else if (syncData.operation == 'UPDATE') {
      for (var i = 0; i < this.modelData.suites.length; i++) {
        if (this.modelData.suites[i].suiteId == syncData.data.suiteId) {
          return this.modelData.suites[i].suiteName = syncData.data.suiteName
        }
      }
    } else if (syncData.operation == 'DELETE') {
      for (var i = 0; i < this.modelData.suites.length; i++) {
        if (this.modelData.suites[i].suiteId == syncData.suiteId) {
          return this.modelData.suites.splice(i, 1);
        }
      }
    } else if (syncData.operation == 'PUSH') {
      this.selectedSuite = this.modelData.suites.find(
        (item: any) => item.suiteId == syncData.suiteId
      );
      if (this.selectedSuite.scenarios.length > 0) {
        syncData.data.forEach((id: any) => {
          for (var i = 0; i < this.selectedSuite.scenarios.length; i++) {
            if (this.selectedSuite.scenarios[i] != id) {
              this.selectedSuite.scenarios.push(id);
              return;
            }
          }
        });
      } else {
        this.selectedSuite.scenarios = syncData.data;
      }
    } else if (syncData.operation == 'SPLICE') {
      this.selectedSuite = this.modelData.suites.find(
        (item: any) => item.suiteId == syncData.suiteId
      );
      syncData.data.forEach((id: any) => {
        var isPresent = this.selectedSuite.scenarios.findIndex(
          (scenID: any) => scenID == id
        );
        if (isPresent > -1) {
          this.selectedSuite.scenarios.splice(isPresent, 1);
        }
      });
    }
    this._sharedService.updateProject(this.modelData);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }



  //new data sync code start
  getModuleDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var module1 = array2.find(
        (item: any) => item.mID == array1[i].mID
      );
      var module2 = array3.find(
        (item: any) => item.mID == array1[i].mID
      );
      var stringfiedModule = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedModule) {
        this.updateModuleOverwriteToModel(array1[i]);
      }
      if (!module1 && !module2) {
        // console.log("Add", array1[i]);
        this.addModuleToModel(array1[i]);
      }
      if (!module1 && module2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.mID == array3[j].mID
      );
      if (!deleted) {
        this.deletemoduleFromModel(array3[j]);
      }
    }
  }
  getPersonaDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var persona1 = array2.find(
        (item: any) => item.pType == array1[i].pType
      );
      var persona2 = array3.find(
        (item: any) => item.pType == array1[i].pType
      );
      var stringfiedpersona = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedpersona) {
        this.updatepersonaOverwriteToModel(array1[i]);
      }
      if (!persona1 && !persona2) {
        console.log("Add", array1[i]);
        this.addpersonaToModel(array1[i]);
      }
      if (!persona1 && persona2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.pType == array3[j].pType
      );
      if (!deleted) {
        this.deletepersonaFromModel(array3[j]);
      }
    }
  }
  getEUTDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => item.eID == array1[i].eID
      );
      var task2 = array3.find(
        (item: any) => item.eID == array1[i].eID
      );
      var stringfiedEUT = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedEUT) {
        this.updateEUTOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addEUTToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.eID == array3[j].eID
      );
      if (!deleted) {
        this.deleteEUTFromModel(array3[j]);
      }
    }
  }
  getTasksDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => item.taskId == array1[i].taskId
      );
      var task2 = array3.find(
        (item: any) => item.taskId == array1[i].taskId
      );
      var stringfiedTask = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedTask) {
        this.updateTaskOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addTasksToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.taskId == array3[j].taskId
      );
      if (!deleted) {
        this.deleteTaskFromModel(array3[j]);
      }
    }
  }
  getEnvDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => item.envID == array1[i].envID
      );
      var task2 = array3.find(
        (item: any) => item.envID == array1[i].envID
      );
      var stringfiedEnv = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedEnv) {
        this.updateEnvOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addEnvToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.envID == array3[j].envID
      );
      if (!deleted) {
        this.deleteEnvFromModel(array3[j]);
      }
    }
  }
  getPMapDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => (item.pType == array1[j].pType && item.eID == array1[j].eID)
      );
      var task2 = array3.find(
        (item: any) => (item.pType == array1[j].pType && item.eID == array1[j].eID)
      );
      var stringfiedPMap = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedPMap) {
        this.updatePMapOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addPMapToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => (item.pType == array3[j].pType && item.eID == array3[j].eID)
      );
      if (!deleted) {
        this.deletePMapFromModel(array3[j]);
      }
    }
  }

  getIMapDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => (item.eut2 == array1[j].eut2 && item.eut1 == array1[j].eut1)
      );
      var task2 = array3.find(
        (item: any) => (item.eut2 == array1[j].eut2 && item.eut1 == array1[j].eut1)
      );
      var stringfiedPMap = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedPMap) {
        this.updateIMapOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addIMapToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => (item.eut2 == array3[j].eut2 && item.eut1 == array3[j].eut1)
      );
      if (!deleted) {
        this.deleteIMapFromModel(array3[j]);
      }
    }
  }
  getSMapDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => (item.aType == array1[j].aType && item.eID == array1[j].eID)
      );
      var task2 = array3.find(
        (item: any) => (item.aType == array1[j].aType && item.eID == array1[j].eID)
      );
      var stringfiedPMap = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedPMap) {
        this.updateSMapOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addSMapToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => (item.aType == array3[j].aType && item.eID == array3[j].eID)
      );
      if (!deleted) {
        this.deleteSMapFromModel(array3[j]);
      }
    }
  }
  getEMapDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => item.envId == array1[i].envId
      );
      var task2 = array3.find(
        (item: any) => item.envId == array1[i].envId
      );
      var stringfiedEnv = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedEnv) {
        this.updateEMapOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addEMapToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.envId == array3[j].envId
      );
      if (!deleted) {
        this.deleteEMapFromModel(array3[j]);
      }
    }
  }
  getScenarioDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => item.scenID == array1[i].scenID
      );
      var task2 = array3.find(
        (item: any) => item.scenID == array1[i].scenID
      );
      var stringfiedEnv = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedEnv) {
        this.updateScenarioOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addScenarioToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.scenID == array3[j].scenID
      );
      if (!deleted) {
        this.deleteScenarioFromModel(array3[j]);
      }
    }
  }
  getEUTdetDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => item.eID == array1[i].eID
      );
      var task2 = array3.find(
        (item: any) => item.eID == array1[i].eID
      );
      var stringfiedEUT = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedEUT) {
        this.updateEUTdetOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addEUTdetToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.eID == array3[j].eID
      );
      if (!deleted) {
        this.deleteEUTdetFromModel(array3[j]);
      }
    }
  }
  getEUTNoteDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => item.eID == array1[i].eID
      );
      var task2 = array3.find(
        (item: any) => item.eID == array1[i].eID
      );
      var stringfiedEUT = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedEUT) {
        this.updateEUTNoteOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addEUTNoteToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.eID == array3[j].eID
      );
      if (!deleted) {
        this.deleteEUTNoteFromModel(array3[j]);
      }
    }
  }
  getSuiteDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => item.suiteId == array1[i].suiteId
      );
      var task2 = array3.find(
        (item: any) => item.suiteId == array1[i].suiteId
      );
      var stringfiedEUT = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedEUT) {
        this.updateSuiteOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addSuiteToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => item.suiteId == array3[j].suiteId
      );
      if (!deleted) {
        this.deleteSuiteFromModel(array3[j]);
      }
    }
  }
  getRunIDifference(array1: any, array2: any, array3: any) {

    for (var i = 0; i < array1.length; i++) {
      var task1 = array2.find(
        (item: any) => (item.scenID == array1[j].scenID && item.buildID == array1[j].buildID)
      );
      var task2 = array3.find(
        (item: any) => (item.scenID == array1[j].scenID && item.buildID == array1[j].buildID)
      );
      var stringfiedPMap = array2.find(
        (item: any) => JSON.stringify(item) == JSON.stringify(array1[i])
      );
      if (!stringfiedPMap) {
        this.updateRunIOverwriteToModel(array1[i]);
      }
      if (!task1 && !task2) {
        // console.log("Add", array1[i]);
        this.addRunIToModel(array1[i]);
      }
      if (!task1 && task2) {
        // console.log("Delete", array1[i]);
      }
    }
    for (var j = 0; j < array3.length; j++) {
      var deleted = array1.find(
        (item: any) => (item.scenID == array3[j].scenID && item.buildID == array3[j].buildID)
      );
      if (!deleted) {
        this.deleteRunIFromModel(array3[j]);
      }
    }
  }

  addModuleToModel(newModule: any) {
    this.modelData.modules.unshift(newModule);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deletemoduleFromModel(module: any) {
    for (var j = 0; j < this.modelData.modules.length; j++) {
      if (this.modelData.modules[j].mID == module.mID) {
        if (j >= 0) {
          return this.modelData.modules.splice(j, 1);
        }
      }
    }
  }
  addpersonaToModel(newPersona: any) {
    console.log("newPersona", newPersona);
    this.modelData.persona.unshift(newPersona);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deletepersonaFromModel(persona: any) {
    for (var j = 0; j < this.modelData.persona.length; j++) {
      if (this.modelData.persona[j].pType == persona.pType) {
        if (j >= 0) {
          return this.modelData.persona.splice(j, 1);
        }
      }
    }
  }
  addEUTToModel(newEUT: any) {
    this.modelData.listOfEUTs.unshift(newEUT);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteEUTFromModel(eut: any) {
    for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
      if (this.modelData.listOfEUTs[j].eID == eut.eID) {
        if (j >= 0) {
          return this.modelData.listOfEUTs.splice(j, 1);
        }
      }
    }
  }
  addTasksToModel(newTask: any) {
    this.modelData.tasks.unshift(newTask);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteTaskFromModel(task: any) {
    for (var j = 0; j < this.modelData.tasks.length; j++) {
      if (this.modelData.tasks[j].taskId == task.taskId) {
        if (j >= 0) {
          return this.modelData.tasks.splice(j, 1);
        }
      }
    }
  }
  addEnvToModel(newEnv: any) {
    this.modelData.listOfEnv.unshift(newEnv);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteEnvFromModel(env: any) {
    for (var j = 0; j < this.modelData.listOfEnv.length; j++) {
      if (this.modelData.listOfEnv[j].envID == env.envID) {
        if (j >= 0) {
          return this.modelData.listOfEnv.splice(j, 1);
        }
      }
    }
  }
  addPMapToModel(newPMap: any) {
    this.modelData.personaMap.unshift(newPMap);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deletePMapFromModel(pMap: any) {
    for (var j = 0; j < this.modelData.personaMap.length; j++) {
      if (this.modelData.personaMap[j].eID == pMap.eID && this.modelData.personaMap[j].pType == pMap.pType) {
        if (j >= 0) {
          return this.modelData.personaMap.splice(j, 1);
        }
      }
    }
  }
  addIMapToModel(newIMap: any) {
    this.modelData.interactionMap.unshift(newIMap);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteIMapFromModel(IMap: any) {
    for (var j = 0; j < this.modelData.interactionMap.length; j++) {
      if (this.modelData.interactionMap[j].eut1 == IMap.eut1 && this.modelData.interactionMap[j].eut2 == IMap.eut2) {
        if (j >= 0) {
          return this.modelData.interactionMap.splice(j, 1);
        }
      }
    }
  }

  addSMapToModel(newSMap: any) {
    this.modelData.scopeMap.unshift(newSMap);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteSMapFromModel(SMap: any) {
    for (var j = 0; j < this.modelData.scopeMap.length; j++) {
      if (this.modelData.scopeMap[j].aType == SMap.aType && this.modelData.scopeMap[j].eID == SMap.eID) {
        if (j >= 0) {
          return this.modelData.scopeMap.splice(j, 1);
        }
      }
    }
  }
  addEMapToModel(newEnv: any) {
    this.modelData.envMap.unshift(newEnv);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteEMapFromModel(env: any) {
    for (var j = 0; j < this.modelData.envMap.length; j++) {
      if (this.modelData.envMap[j].envId == env.envId) {
        if (j >= 0) {
          return this.modelData.envMap.splice(j, 1);
        }
      }
    }
  }
  addScenarioToModel(newScen: any) {
    this.modelData.scenarios.unshift(newScen);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteScenarioFromModel(scen: any) {
    for (var j = 0; j < this.modelData.scenarios.length; j++) {
      if (this.modelData.scenarios[j].scenID == scen.scenID) {
        if (j >= 0) {
          return this.modelData.scenarios.splice(j, 1);
        }
      }
    }
  }
  addEUTdetToModel(newEUT: any) {
    this.modelData.EUTdetails.unshift(newEUT);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteEUTdetFromModel(eut: any) {
    for (var j = 0; j < this.modelData.EUTdetails.length; j++) {
      if (this.modelData.EUTdetails[j].eID == eut.eID) {
        if (j >= 0) {
          return this.modelData.EUTdetails.splice(j, 1);
        }
      }
    }
  }
  addEUTNoteToModel(newEUT: any) {
    this.modelData.myNotes.unshift(newEUT);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteEUTNoteFromModel(eut: any) {
    for (var j = 0; j < this.modelData.myNotes.length; j++) {
      if (this.modelData.myNotes[j].eID == eut.eID) {
        if (j >= 0) {
          return this.modelData.myNotes.splice(j, 1);
        }
      }
    }
  }
  addSuiteToModel(newSuite: any) {
    this.modelData.suites.unshift(newSuite);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteSuiteFromModel(suite: any) {
    for (var j = 0; j < this.modelData.suites.length; j++) {
      if (this.modelData.suites[j].suiteId == suite.suiteId) {
        if (j >= 0) {
          return this.modelData.suites.splice(j, 1);
        }
      }
    }
  }
  addRunIToModel(newrun: any) {
    this.modelData.personaMap.unshift(newrun);
    this.modelDataCopy = JSON.stringify(this.modelData);
  }
  deleteRunIFromModel(run: any) {
    for (var j = 0; j < this.modelData.runInfo.length; j++) {
      if (this.modelData.runInfo[j].scenID == run.scenID && this.modelData.runInfo[j].buildID == run.buildID) {
        if (j >= 0) {
          return this.modelData.runInfo.splice(j, 1);
        }
      }
    }
  }


  updateModuleOverwriteToModel(updateModule: any) {
    for (var i = 0; i < this.modelData.modules.length; i++) {
      if (this.modelData.modules[i].mID == updateModule.mID) {
        this.modelData.modules[i] = updateModule;
      }
    }
  }
  updatepersonaOverwriteToModel(updatePersona: any) {
    for (var i = 0; i < this.modelData.persona.length; i++) {
      if (this.modelData.persona[i].pType == updatePersona.pType) {
        this.modelData.persona[i] = updatePersona;
      }
    }
  }
  updateEUTOverwriteToModel(updateEUT: any) {
    for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
      if (this.modelData.listOfEUTs[i].eID == updateEUT.eID) {
        this.modelData.listOfEUTs[i] = updateEUT;
      }
    }
  }
  updateTaskOverwriteToModel(updateTask: any) {
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      if (this.modelData.tasks[i].taskId == updateTask.taskId) {
        this.modelData.tasks[i] = updateTask;
      }
    }
  }
  updateEnvOverwriteToModel(updateEnv: any) {
    for (var i = 0; i < this.modelData.listOfEnv.length; i++) {
      if (this.modelData.listOfEnv[i].envID == updateEnv.envID) {
        this.modelData.listOfEnv[i] = updateEnv;
      }
    }
  }
  updatePMapOverwriteToModel(updatePMap: any) {
    for (var i = 0; i < this.modelData.personaMap.length; i++) {
      if (this.modelData.personaMap[i].eID == updatePMap.eID && this.modelData.personaMap[i].pType == updatePMap.pType) {
        this.modelData.personaMap[i] = updatePMap;
      }
    }
  }
  updateIMapOverwriteToModel(updateIMap: any) {
    for (var i = 0; i < this.modelData.interactionMap.length; i++) {
      if (this.modelData.interactionMap[i].eut2 == updateIMap.eut2 && this.modelData.interactionMap[i].eut1 == updateIMap.eut1) {
        this.modelData.interactionMap[i] = updateIMap;
      }
    }
  }
  updateSMapOverwriteToModel(updateSMap: any) {
    for (var i = 0; i < this.modelData.scopeMap.length; i++) {
      if (this.modelData.scopeMap[i].aType == updateSMap.aType && this.modelData.scopeMap[i].eID == updateSMap.eID) {
        this.modelData.scopeMap[i] = updateSMap;
      }
    }
  }
  updateEMapOverwriteToModel(updateEMap: any) {
    for (var i = 0; i < this.modelData.envMap.length; i++) {
      if (this.modelData.envMap[i].envId == updateEMap.envId) {
        this.modelData.envMap[i] = updateEMap;
      }
    }
  }
  updateScenarioOverwriteToModel(updateScenario: any) {
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (this.modelData.scenarios[i].scenID == updateScenario.scenID) {
        this.modelData.scenarios[i] = updateScenario;
      }
    }
  }
  updateEUTdetOverwriteToModel(updateEUT: any) {
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == updateEUT.eID) {
        this.modelData.EUTdetails[i] = updateEUT;
      }
    }
  }
  updateEUTNoteOverwriteToModel(updateEUT: any) {
    for (var i = 0; i < this.modelData.myNotes.length; i++) {
      if (this.modelData.myNotes[i].eID == updateEUT.eID) {
        this.modelData.myNotes[i] = updateEUT;
      }
    }
  }
  updateSuiteOverwriteToModel(updateSuite: any) {
    for (var i = 0; i < this.modelData.suites.length; i++) {
      if (this.modelData.suites[i].suiteId == updateSuite.suiteId) {
        this.modelData.suites[i] = updateSuite;
      }
    }
  }
  updateRunIOverwriteToModel(updateRun: any) {
    for (var i = 0; i < this.modelData.runInfo.length; i++) {
      if (this.modelData.runInfo[i].scenID == updateRun.scenID && this.modelData.runInfo[i].buildID == updateRun.buildID) {
        this.modelData.runInfo[i] = updateRun;
      }
    }
  }

  //new data sync code end
  applyTheme(name: any) {
    document.body.className = name;

    if (this.project) {
      this.project.views.applyTheme();
    }
  }

  groupMgmt() {
    this.createActivity('GM');
    this.modalHideOnSuccess();
    // window.location = "/groupmanagement";
    $('.modal-backdrop').remove();
  }

  //Browser crash event to handle active user session
  // window.addEventListener('beforeunload', (event:any)=> {
  //   console.log("event", window.event);
  //   // $localStorage.setItem('event', event);
  //   // alert(event);
  //   // return;
  //   // if (event.keyCode != 116) { // User presses F5 to refresh
  //   //   this.logout();
  //   // }
  //   // this.logout();
  // });

  logout() {
    this.projectOpen = false;
    this.readmode(true);
    this.socket.disconnect();
    this.clearActiveUser(this.clientSocketID);
    this.createActivity('Lo');
    this.cookieService.delete('UserName');
    this.modalHideOnSuccess();
    $('.modal-backdrop').remove();
    localStorage.clear();
    this.cookieService.delete('language');
    this.cookieService.set('language', this.language);
    localStorage.setItem('language', this.language);
    window.location.href = '/login';
  }

  clearActiveUser(socketID: any) {
    // console.log('socketID', socketID);
    var userID = localStorage.getItem('userID');
    this.ProjectServices.deleteActiveUser(userID).subscribe((response: any) => {
      if (response.statusCode === 200) {
        // console.log('deleteActiveUser res', response);
      } else {
        // console.log('deleteActiveUser res 500', response);
      }
    });
  }

  loadEut(name: any) {
    if (name == 'Pm') {
      this.personaMapper.init();
    } else if (name == 'Sc') {
      this.scopeMapper.init();
    } else if (name == 'Im') {
      this.interactionMapper.init();
    } else if (name == 'Db') {
      this.dashboard.init();
    } else if (name == 'Dd') {
      this.deepDive.init();
    }
  }

  expandNotesTab(status: any) {
    if (status == true) {
      $("#myNote").addClass('extentedNotes');
    } else {
      $("#myNote").removeClass('extentedNotes');
    }
  }

  errorMsgPopup(value: any) {
    if (value == 'Pm') {
      this.noDataPopupMsg = "No personas/requirements to map.";
    } else if (value == 'Im') {
      this.noDataPopupMsg = "No entities to map.";
    } else if (value == 'Sc') {
      this.noDataPopupMsg = "No entities to map.";
    } else if (value == 'Ed') {
      this.noDataPopupMsg = "No environments to map.";
    } else if (value == 'Tp') {
      this.noDataPopupMsg = "No entities yet!";
    } else if (value == 'Dd') {
      this.noDataPopupMsg = "No entities to map.";
    } else if (value == 'Td') {
      this.noDataPopupMsg = "No entities to map.";
    } else if (value == 'Ex') {
      this.noDataPopupMsg = "No entities yet!";
    } else if (value == 'Tm') {
      this.noDataPopupMsg = "No persons/entities to map.";
    } else if (value == 'Db') {
      this.noDataPopupMsg = "No dashboard data to show.";
    }
  }

  setArguementsForTool(taskDetails: any) {
    var envName = '';
    var testTypes = [
      {
        name: 'Feature Behaviour',
        symbol: 'Fe',
        eType: 'TF',
      },
      {
        name: 'Requirement Behaviour',
        symbol: 'Rb',
        eType: 'UR',
      },
      {
        name: 'Flow Behaviour',
        symbol: 'Fb',
        eType: 'BF',
      },
    ];
    // new code open
    // console.log('taskDetails Sprint', taskDetails);
    // console.log('this.project.model.listOfEUTs', this.project.model.listOfEUTs);

    var entity = this.project.model.listOfEUTs.find(
      (entity: any) => entity.eID == taskDetails.entity_Id
    );
    // console.log('entity', entity);
    var testType: any = this.Config.listOfAttributesUpdated.find(
      (attribute: any) => attribute.name == taskDetails.attribute
    );
    if (!testType) {
      testType = testTypes.find(
        (attribute) => attribute.name == taskDetails.attribute
      );
    }
    // console.log('testType', testType);
    envName = taskDetails.environment;
    // console.log('envName', envName);
    if (taskDetails.toolType == 'cl') {
      localStorage.setItem(
        'checklistDetails',
        JSON.stringify(taskDetails.checklistDetails)
      );
      this.goToView();
      this.checklist.controller.chooseChecklist(
        false,
        false,
        taskDetails.checklistDetails
      );
      this.checklist.controller.generateReport();
    } else if (taskDetails.toolType == 'im') {
      this.interactionMapperMindmap.controller.selectedEUT = taskDetails.entityType;
      this.interactionMapperMindmap.controller.activate(entity);
    } else if (taskDetails.toolType == 'dd') {
      this.deepDive.controller.selectedEUT = taskDetails.entityType;
      this.deepDive.controller.activate(entity);
    } else if (taskDetails.toolType == 'de') {
      this.testDesigner.controller.selectedEUT = taskDetails.entityType;
      this.testDesigner.controller.activate(entity, testType);
    } else if (taskDetails.toolType == 'tm') {
      this.goToView();
      // this.testManager.controller.switchTab('suites');
      // this.testManager.controller.chooseSuite(false, false, taskDetails.suiteDetails);
      let suitesArray = ['Suites'];
      localStorage.setItem('exportedData', JSON.stringify(suitesArray));
      localStorage.setItem('selectedSuite', taskDetails.suiteDetails.suiteName);
      // this.testManager.controller.generateReport();
    } else if (taskDetails.toolType == 'ex') {
      this.validator.controller.selectedEUT = taskDetails.entityType;
      this.validator.controller.activate(entity, testType, envName);
    }
    // new code close

    // var envName = '';
    // var checklist = '';

    // if (entity) {
    //   if (entity.eName != "") {
    //     if (params.indexOf('Do Deepdive for') != -1) {
    //       this.deepDive.controller.activate(entity);
    //     } else if (params.indexOf('Do Design') != -1) {
    //       // this.testDesigner.app.init();
    //       this.testDesigner.controller.activate(entity, testType);
    //     } else if (params.indexOf('Do Validate') != -1) {
    //       this.validator.controller.activate(entity, testType, envName);
    //     }
    //   }
    // }
    // if (params.indexOf('Execute') != -1) {
    //   entityName = params.split('Execute ').pop().split(' for')[0];
    //   checklist = 'true';
    //   envName = params.split('in ').pop();
    //   this.validator.controller.activate(entityName, testType, envName, checklist);
    // }
  }

  addScenarioEntityType(type: any) {
    if (this.entityTypeScenario.indexOf(type) > -1) {
      this.entityTypeScenario = this.entityTypeScenario.filter(
        (e: any) => e !== type
      );
    } else {
      this.entityTypeScenario.push(type);
    }
  }

  //get params to export report
  getParamsToExport(value: any) {
    if (value == 'userList') {
      this.addParamsToExport(this.Config.exportReportParams.userList);
    } else if (value == 'projectSum') {
      this.addParamsToExport(this.Config.exportReportParams.projectSum);
      localStorage.setItem('Entities', JSON.stringify(['TF', 'UR', 'BF']));
    } else if (value == 'designSum') {
      this.addParamsToExport(this.Config.exportReportParams.designSum);
      localStorage.setItem('Entities', JSON.stringify(['TF', 'UR', 'BF']));
    } else if (value == 'eutList') {
      this.addParamsToExport(this.Config.exportReportParams.EUTList);
      // this.addParamsToExport(this.Config.exportReportParams.MAPS);
      localStorage.setItem('Entities', JSON.stringify(['TF', 'UR', 'BF']));
    } else if (value == 'maps') {
      this.addParamsToExport(this.Config.exportReportParams.MAPS);
      localStorage.setItem('Entities', JSON.stringify(['TF', 'UR', 'BF']));
    } else if (value == 'suites') {
      this.addParamsToExport(this.Config.exportReportParams.Suites);
      localStorage.removeItem('selectedSuite');
    } else if (value == 'summary') {
      this.addParamsToExport(this.Config.exportReportParams.Summary);
    }
  }
  //adding params to export report
  addParamsToExport(value: any) {
    for (var i = 0; i < value.length; i++) {
      if (this.exportReportArray.indexOf(value[i]) > -1) {
        this.exportReportArray = this.exportReportArray.filter(
          (e: any) => e !== value[i]
        );
      } else {
        this.exportReportArray.push(value[i]);
      }
    }
  }

  exportSelectedReport() {
    // if (this.entityTypeScenario.length > 0) {
    //   localStorage.removeItem('deepdiveSelected');
    //   this.exportReportArray.push('Scenarios');
    //   localStorage.setItem(
    //     'scenarioEntity',
    //     JSON.stringify(this.entityTypeScenario)
    //   );
    // }
    if (this.exportReportArray.length > 0) {
      localStorage.setItem(
        'exportedData',
        JSON.stringify(this.exportReportArray)
      );
      this.exportReportArray = [];
      window.open('/exportReport', '_blank');
      localStorage.setItem('autoDownload', 'true');
    }
    $('#downloadPopupModel').on('hidden.bs.modal', (e: any) => {
      $(this).find('input[type=checkbox]').prop('checked', '').end();
    });
    $('#hamburgerMenu').modal('hide');
  }

  dwnldModalCancel() {
    $('#downloadPopupModel').on('hidden.bs.modal', (e: any) => {
      $(this).find('input[type=checkbox]').prop('checked', '').end();
    });
  }

  // function to hide project mgmt popup modal when users clicks yes button in confirm popup
  hideProjectMgmtModal() {
    $('#projectMgmtPopupModel').modal('hide');
    $('#projectUsersUpdateConfirmPopupModel').modal('hide');
  }

  /*
   * Function to generate or create a logs based on selected Tool name
   */

  getVideoURL(urlName: any) {
    this.videoURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.appService.getVideoURL(urlName));
    // if (
    //   urlName == 'testCaseQuality' ||
    //   urlName == 'testExecutionQuality' ||
    //   urlName == 'cleanlinessDegree'
    // ) {
    //   setTimeout(() => {
    //     var element: any = document.getElementById(urlName + 'VideoLink') || {};
    //     element.src = this.videoURL;
    //   }, 1000);
    // } else {
    //   var element: any = document.getElementById(urlName + 'VideoLink') || {};
    //   element.src = this.videoURL;
    // }
  }

  // Function to validate the EMAIL regix
  validateEmailID(email: any) {
    var re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;
    return re.test(email);
  }
  /*
   * Function to invite user to join in Org through E-mail invitation
   */
  addUserToOrg(invite: any) {
    if (invite == '') {
      this.triggerToast(this.appService.getResourceText('V013'));
      return;
    } else if (!this.validateEmailID(invite)) {
      this.triggerToast(this.appService.getResourceText('V008'));
      return;
    }
    var emailObj: any = { emailId: invite };
    this.userManagementService
      .inviteUser(emailObj)
      .subscribe((response: any) => {
        // console.log('inviteUser response', response);
        if (response.statusCode === 200) {
          this.inviteMessage = this.appService.getResourceText('B021');
          this.inviteMailId = '';
          $('#orgAddUserConfirmPopupModel').modal('hide');
          $('#orgAddPopupModel').modal('hide');
          $('#orgAddSuccessPopupModel').modal('show');
          setTimeout(() => {
            $('#orgAddSuccessPopupModel').modal('hide');
          }, 3000);
        } else if (response.statusCode === 206) {
          this.inviteMessage = this.appService.getResourceText('B022');
          $('#orgAddUserConfirmPopupModel').modal('hide');
          $('#orgAddPopupModel').modal('hide');
          $('#orgAddSuccessPopupModel').modal('show');
          setTimeout(() => {
            $('#orgAddSuccessPopupModel').modal('hide');
            $('#orgAddPopupModel').modal('show');
          }, 3000);
        } else if (response.statusCode === 401) {
          this.inviteMessage = this.appService.getResourceText('B000');
          this.inviteMailId = '';
          $('#orgAddSuccessPopupModel').modal('show');
          setTimeout(function () {
            $('#orgAddSuccessPopupModel').modal('hide');
          }, 3000);
        } else {
          this.inviteMessage = this.appService.getResourceText('B002');
          this.inviteMailId = '';
          $('#orgAddSuccessPopupModel').modal('show');
          setTimeout(function () {
            $('#orgAddSuccessPopupModel').modal('hide');
          }, 3000);
        }
      });
  }

  /*
   * Function to adding user directly to organization by showing confirm message
   */
  checkUserExistsinSystem(invite: any) {
    if (invite == '') {
      // console.log('before triggerToast call25');
      this.triggerToast(this.appService.getResourceText('V013'));
      return;
    } else if (!this.validateEmailID(invite)) {
      // console.log('before triggerToast call26');
      this.triggerToast(this.appService.getResourceText('V008'));
      return;
    }
    var emailObj: any = { emailId: invite };
    this.userManagementService
      .checkUserExistsinSystem(emailObj)
      .subscribe((response: any) => {
        // console.log('checkUserExistsinSystem response', response);
        if (response.statusCode === 200) {
          // triggerToast(response.data);
          if (response.exists === 1) {
            this.inviteMessage = this.appService.getResourceText('B020');
            $('#orgAddPopupModel').modal('hide');
            $('#orgAddUserConfirmPopupModel').modal('show');
          } else {
            this.addUserToOrg(invite);
          }
        } else if (response.statusCode === 401) {
          this.inviteMessage = this.appService.getResourceText('B000');
          this.inviteMailId = '';
          $('#orgAddSuccessPopupModel').modal('show');
          setTimeout(function () {
            $('#orgAddSuccessPopupModel').modal('hide');
          }, 3000);
        } else {
          this.inviteMessage = this.appService.getResourceText('B002');
          this.inviteMailId = '';
          $('#orgAddSuccessPopupModel').modal('show');
          setTimeout(function () {
            $('#orgAddSuccessPopupModel').modal('hide');
          }, 3000);
        }
      });
  }

  emptyInviteField() {
    this.inviteMailId = '';
  }

  // to get users from Org
  getOrgUsers() {
    this.userManagementService.getUsersFromOrg().subscribe((response: any) => {
      if (response.statusCode === 200) {
        this.orgUserList = response.records;
        this.inviteMailId = '';
        this.selectToRemoveUsr = '';
        this.selectAdmin = '';
      } else if (response.statusCode === 401) {
        this.triggerToast(this.appService.getResourceText('B000'));
        // localStorage.clear();
        $('#orgListPopupModel').modal('hide');
        $('#orgAddPopupModel').modal('hide');
        $('#orgDeletePopupModel').modal('hide');
        $('#orgAdminChangePopupModel').modal('hide');
        $('#hamburgerMenu').modal('hide');
        setTimeout(function () {
          window.location.href = '/login';
        }, 3000);
      } else if (response.statusCode === 500) {
        // triggerToast(this.appService.getResourceText("B002"));
      }
    });
  }

  getOrgUsersByProjectOrgID(currProject: any) {
    this.userManagementService
      .getUsersFromProjectOrgID(currProject)
      .subscribe((response: any) => {
        if (response.statusCode === 200) {
          this.orgUserListByProject = response.records;
        } else if (response.statusCode === 401) {
          this.triggerToast(this.appService.getResourceText('B000'));
          // localStorage.clear();
          $('#orgListPopupModel').modal('hide');
          $('#orgAddPopupModel').modal('hide');
          $('#orgDeletePopupModel').modal('hide');
          $('#orgAdminChangePopupModel').modal('hide');
          $('#hamburgerMenu').modal('hide');
          setTimeout(function () {
            window.location.href = '/login';
          }, 3000);
        } else if (response.statusCode === 500) {
          // triggerToast(this.appService.getResourceText("B002"));
        }
      });
  }

  // function to generate toast message bar
  triggerToast(message: any) {
    // console.log('toast message', message);
    this.toastMsg = message;
    // this.feedbackErrorMessage = message;
    // $('#snackbar').html(message);
    // var x: any = document.getElementById('snackbar');
    // x.className = 'show';
    setTimeout(() => {
      this.feedbackErrorMessage = '';
    }, 3000);
    $('#errorMessagePopup').modal('show');
  }

  triggerToastMessage(message: any) {
    this.toastMsg = message;
    this.changePwdMessage = message;
    // $('#changePwdMessage').html(message);
    // var x: any = document.getElementById('changePwdMessage');
    // x.className = 'show';
    setTimeout(() => {
      this.changePwdMessage = '';
      this.toastMsg = '';
      // x.className = x.className.replace('show', '');
      // $("#changePwdMessage").removeClass("show");
    }, 5000);
  }

  triggerToastJiraUpdate(message: any) {
    // console.log('triggerToastJiraUpdate message', message);
    this.toastMsg = message;
    $('#jiraUpdateToast').addClass('show');
    setTimeout(() => {
      $("#jiraUpdateToast").removeClass("show");
    }, 3000);
  }

  // triggerToastforOpenPeoject(message: any) {
  //   this.toastMsg = message;
  //   $('#snackbar1').html(message);
  //   var x: any = document.getElementById('snackbar1');
  //   x.className = 'show';
  //   setTimeout(() => {
  //     x.className = x.className.replace('show', '');
  //   }, 3000);
  // }

  selectAddUser(user: any, event: any) {
    if (event == true) {
      this.projectUserListIds.push(user._id);
    } else {
      this.projectUserListIds = this.projectUserListIds.filter(
        (usr: any) => usr != user._id
      );
    }
    // console.log('this.projectUserListIds', this.projectUserListIds);
  }

  // function to send individual or group message using sockets
  sendMessage(message: any) {
    // console.log('this.chatUsersList', this.chatUsersList);
    if (this.chatUsersList.length == 0) {
      return;
    } else if (this.chatUsersList.length == 1) {
      var checkSender = this.chatUsersList.find(
        (user: any) => user.userId == this.myUserID
      );
      // console.log('checkSender', checkSender);
      if (checkSender) {
        return;
      }
    }
    // console.log('message to be send', message);
    var sender: any = this.currentActiveUsers.find(
      (user: any) => user.userId == this.myUserID
    );
    // console.log('sender', sender);
    var senderPresent: any = this.chatUsersList.find(
      (user: any) => user.userId == this.myUserID
    );
    // console.log('senderPresent', senderPresent);
    if (!senderPresent) {
      this.chatUsersList.push(sender);
    }
    let senderMsgObj: any = {
      fromUser: sender.username,
      fromId: sender.userId,
      message: message,
    };
    this.chatMessages.push(senderMsgObj);
    this.socket.emit(
      'chatbox',
      JSON.stringify({
        users: this.chatUsersList,
        message: message,
        from: sender,
      })
    );
    this.messageContent = '';
    this.selectAllToChatbox(true);
  }

  selectAllToChatbox(event: any) {
    // console.log('event in selectall', event);
    this.chatUsersList = [];
    this.selectAll = false;
    if (event == true) {
      for (let u = 0; u < this.currentActiveUsers.length; u++) {
        // this.addUserToChatbox(this.currentActiveUsers[u], true);
        if (this.currentActiveUsers[u].userId != this.myUserID) {
          this.chatUsersList.push(this.currentActiveUsers[u]);
        }
      }
      this.selectAll = true;
      $('.chatUsersCheckbox').prop('checked', false);
    } else {
      this.selectAll = false;
    }
    $('#allUsernames').prop('checked', false);
    // $('#selectAll').attr('checked');
    $('#selectAll').attr('checked', 'checked');
    // console.log("this.chatUsersList",this.chatUsersList);
    this.dropdownTitle = true;
  }

  addUserToChatbox(user: any, event: any) {
    // console.log('user', user);
    if (this.selectAll == true) {
      this.chatUsersList = [];
    }
    $('#selectAll').removeAttr('checked');
    if (event == true) {
      this.chatUsersList.push(user);
    } else {
      this.chatUsersList = this.chatUsersList.filter(
        (usr: any) => usr._id != user._id
      );
    }

    // if (this.chatUsersList.length == 1) {
    //   var checkSender = this.chatUsersList.find(user => user.userId == this.myUserID);
    //   console.log('checkSender', checkSender);
    //   if (checkSender) {
    //     // return;
    //   }
    // }
    // console.log('chatlist', this.chatUsersList);
    this.selectAll = false;
    this.dropdownTitle = false;
    if (this.chatUsersList.length == 0) {
      this.selectAllToChatbox(true);
    }
  }

  checkProjectUserUpdate(proUsers: any, selectedUsers: any) {
    this.delProUsers = [];
    // console.log('proUsers', proUsers);
    // console.log('selectedUsers', selectedUsers);
    for (let u = 0; u < proUsers.length; u++) {
      let userFound = selectedUsers.find(
        (user: any) => user == proUsers[u]._id
      );
      // console.log('userFound', userFound);
      if (!userFound) {
        this.delProUsers.push(proUsers[u]);
        // console.log('this.delProUsers', this.delProUsers);
      }
    }
    if (this.delProUsers.length >= 1) {
      $('#projectUsersUpdateConfirmPopupModel').modal('show');
    } else {
      this.projectUsersUpdate(selectedUsers);
    }
  }

  projectUsersUpdate(userIds: any) {
    var adminFound = false;
    for (let i = 0; i < this.orgUserList.length; i++) {
      if (this.orgUserList[i].userrole == 0) {
        for (let j = 0; j < userIds.length; j++) {
          if (this.orgUserList[i]._id == userIds[j]) {
            adminFound = true;
          }
        }
      }
    }

    if (adminFound == false) {
      this.triggerToastMessage(this.appService.getResourceText('V029'));
    } else {
      // console.log("deleteUsers", this.delProUsers);
      if (this.delProUsers.length > 0) {
        for (var i = 0; i < this.delProUsers.length; i++) {
          console.log(this.delProUsers[i]);
          for (var j = 0; j < this.modelData.tasks.length; j++) {
            if (this.delProUsers[i]._id == this.modelData.tasks[j].assignedto) {
              // console.log("assigneduser",this.modelData.tasks[j].assigneduser);
              this.modelData.tasks[j].assignedto = "";
              this.modelData.tasks[j].assigneduser = "";
            }
          }
        }
      }
      let usersObj = {
        applicationID: this.currProject.applicationId,
        users: userIds,
        deleteusers: this.delProUsers,
        projectDetails: this.currProject.projectDetails,
      };
      // console.log("usersObj", usersObj);
      // return;
      this.userManagementService
        .updateUsersFromApplication(usersObj)
        .subscribe((response: any) => {
          if (response.statusCode === 201) {
            if (response.users.length != 0) {
              this.activeUsersDetails = response.users;
              if (response.users.length == 1) {
                this.activeUsersNames = "'" + response.users[0].name + "'";
              } else if (response.users.length > 1) {
                for (let k = 0; k < response.users.length; k++) {
                  if (k != response.users.length) {
                    this.activeUsersNames = response.users[0].name + ', ';
                  } else if ((k = response.users.length)) {
                    this.activeUsersNames = ' and ' + response.users[0].name;
                  }
                }
              }
              // console.log('this.activeUsersNames', this.activeUsersNames);
              $('#projectUsersUpdateErrorPopupModel').modal('show');
            }
          } else if (response.statusCode === 200) {
            this.triggerToast(this.appService.getResourceText('B014'));
          } else {
            // triggerToast(this.appService.getResourceText("B002"));
          }
        });
      $('#projectMgmtPopupModel').modal('hide');
    }
  }
  userAddToProject(user: any) {
    this.projectUserList.push(user);
    this.userList = this.userList.filter((user1: any) => {
      return user1 !== user;
    });
    this.selectedUsrToAdd = '';
    this.isUsrRemoveDisabled = true;
    this.isUsrAddDisabled = true;
  }
  selectRemoveUser(user: any) {
    this.selectedUsrToRemove = user;
    this.isUsrRemoveDisabled = false;
    this.isUsrAddDisabled = true;
  }

  userRemoveFromProject(user: any) {
    this.userList.push(user);
    this.projectUserList = this.projectUserList.filter((user1: any) => {
      return user1 !== user;
    });
    this.selectedUsrToRemove = '';
    this.isUsrRemoveDisabled = true;
    this.isUsrAddDisabled = true;
  }

  /*
   * Function to invite user to join in Org through E-mail invitation
   */
  addUsersToProject(usersList: any) {
    if (usersList.length == 0) {
      // console.log('before triggerToast call29');
      this.triggerToast(this.appService.getResourceText('V012'));
      return;
    } else {
      var addUsersIDs = [];
      for (var i = 0; i < usersList.length; i++) {
        addUsersIDs.push(usersList[i]._id);
      }
    }

    var projectObj = { projectId: this.currProject._id, users: addUsersIDs };
    this._sharedService
      .updateProject(this.currProject)
      .subscribe((response: any) => {
        // console.log('updateProject res', response);
      });

    this.userManagementService
      .addUsersToProject(projectObj)
      .subscribe((response: any) => {
        if (response.statusCode === 200) {
          this.triggerToast(this.appService.getResourceText('B014'));
          $('#projectMgmtPopupModel').modal('hide');
        } else if (response.statusCode === 401) {
          this.triggerToast(this.appService.getResourceText('B000'));
          // localStorage.clear();
          $('#orgListPopupModel').modal('hide');
          $('#orgAddPopupModel').modal('hide');
          $('#orgDeletePopupModel').modal('hide');
          $('#orgAdminChangePopupModel').modal('hide');
          $('#hamburgerMenu').modal('hide');
          setTimeout(function () {
            window.location.href = '/login';
          }, 3000);
        } else if (response.statusCode === 500) {
          // triggerToast(this.appService.getResourceText("B002"));
        }
      });

    // this.ProjectServices.updateProject(this.currProject)
    //   .then(function () {
    //     this.notification.link(
    //       "R007",
    //       true,
    //       function () { },
    //       modalHideOnSuccess
    //     );
    //   });
  }

  openRemoveOrgConfirmPopup(usrID: any) {
    if (this.selectToRemoveUsr == '' || this.selectToRemoveUsr == null) {
      this.userDeleteMessage = this.appService.getResourceText('V011');
      $('#orgUserDeleteSuccessPopupModel').modal('show');
      $('#orgDeletePopupModelConfirm').modal('hide');
      setTimeout(() => {
        $('#orgUserDeleteSuccessPopupModel').modal('hide');
      }, 3000);
      return;
    } else {
      $('#orgDeletePopupModelConfirm').modal('show');
    }
  }

  // Function to remove user from org
  selectUsrToRemoveFromOrg(RemoveUsr: any) {
    if (RemoveUsr == '' || RemoveUsr == null) {
      this.triggerToast(this.appService.getResourceText('V011'));
      return;
    } else {
      var userObj: any = { id: RemoveUsr };
      this.userManagementService
        .removeUserFromOrg(userObj)
        .subscribe((response: any) => {
          if (response.statusCode === 200) {
            this.selectToRemoveUsr = '';
            this.userDeleteMessage = this.appService.getResourceText('B015');
            $('#orgUserDeleteSuccessPopupModel').modal('show');
            $('#orgDeletePopupModelConfirm').modal('hide');
            $('#orgDeletePopupModel').modal('hide');
            setTimeout(() => {
              $('#orgUserDeleteSuccessPopupModel').modal('hide');
            }, 3000);
          } else if (response.statusCode === 401) {
            this.triggerToast(this.appService.getResourceText('B000'));
            // localStorage.clear();
            $('#orgListPopupModel').modal('hide');
            $('#orgAddPopupModel').modal('hide');
            $('#orgDeletePopupModel').modal('hide');
            $('#orgAdminChangePopupModel').modal('hide');
            $('#hamburgerMenu').modal('hide');
            setTimeout(function () {
              window.location.href = '/login';
            }, 3000);
          } else if (response.statusCode === 500) {
            // this.triggerToast(this.appService.getResourceText('B002'));
          }
        });
    }
  }

  changeAdminConfirmPopupOpen(selAdm: any) {
    if (this.selectAdmin == '' || this.selectAdmin == null) {
      this.triggerToast(this.appService.getResourceText('V011'));
      $('#orgAdminChangePopupModelConfirm').modal('hide');
      return;
    } else {
      $('#orgAdminChangePopupModelConfirm').modal('show');
    }
  }

  // Function to change org admin
  selectUsrToMakeAdmin(selectedAdmin: any) {
    if (selectedAdmin == '' || selectedAdmin == null) {
      this.triggerToast(this.appService.getResourceText('V011'));
      return;
    } else {
      var userObj: any = { id: selectedAdmin };
      this.userManagementService
        .orgAdminChange(userObj)
        .subscribe((response: any) => {
          if (response.statusCode === 200) {
            this.selectAdmin = '';
            this.triggerToast(this.appService.getResourceText('B016'));
            $('#orgAdminChangePopupModel').modal('hide');
            $('#hamburgerMenu').modal('hide');
            // localStorage.clear();
            setTimeout(() => {
              window.location.href = '/login';
            }, 3000);
          } else if (response.statusCode === 401) {
            this.triggerToast(this.appService.getResourceText('B000'));
            // localStorage.clear();
            $('#orgListPopupModel').modal('hide');
            $('#orgAddPopupModel').modal('hide');
            $('#orgDeletePopupModel').modal('hide');
            $('#orgAdminChangePopupModel').modal('hide');
            $('#hamburgerMenu').modal('hide');
            setTimeout(function () {
              window.location.href = '/login';
            }, 3000);
          } else if (response.statusCode === 500) {
            // triggerToast(this.appService.getResourceText("B002"));
          }

          //// error res code
        });
    }
  }
  // Function to validate the PASSWORD regix

  validatePassword(password: any) {
    this.errors = [];
    if (password.length < 8) {
      this.errors.push(this.appService.getResourceText('V003'));
    }
    if (password.search(/[a-z]/i) < 0) {
      this.errors.push(this.appService.getResourceText('V004'));
    }
    if (password.search(/[0-9]/) < 0) {
      this.errors.push(this.appService.getResourceText('V005'));
    }
    if (password.search(/[!@#$%^&*]/) < 0) {
      this.errors.push(this.appService.getResourceText('V006'));
    }
    return this.errors;
  }

  changePwdContinue() {
    $('#changePwdFormPopupModal').modal('show');
    this.changepwd = { oldpassword: '', newpassword: '', confirmpassword: '' };
  }

  assistantChanges() {
    this.validateAPIKey = false;
  }
  validateApiKey(assistantSetup: any) {
    // console.log("assistantSetup",assistantSetup);
    if (
      this.selectedAssistantModel == ''
    ) {
      this.triggerToastMessage("Please choose OpenAI model");
      // alert(this.appService.getResourceText('V007'));
      return;
    } else if (
      assistantSetup.token == '' || assistantSetup.maxtokens == ''
    ) {
      this.triggerToastMessage("Please enter API Key");
      // alert(this.appService.getResourceText('V007'));
      return;
    } else if (
      assistantSetup.maxtokens < 500
    ) {
      this.triggerToastMessage("Token can't be below 500");
      // alert(this.appService.getResourceText('V007'));
      return;
    } else {
      this.loader = true;
      var query = 'Is my CHAT GPT API Key is valid';
      this.ProjectServices.triggerChatGPT(query, assistantSetup.token, assistantSetup.maxtokens, this.selectedAssistantModel).subscribe(
        (response: any) => {
          // console.log("ChatGPT", response);
          this.validateAPIKey = true;
          this.triggerToastMessage("API Key is valid" + " (from OpenAI)");
          this.loader = false;
        },
        (error: any) => {
          // console.log("ChatGPT error", error);
          this.validateAPIKey = false;
          if (error.status == "429") {
            this.triggerToastMessage(error.error.error.message + " (from OpenAI)");
            this.loader = false;
          }
          if (error.status == "401") {
            this.triggerToastMessage("Incorrect API key provided" + " (from OpenAI)");
            this.loader = false;
          }
          if (error.status == "404") {
            this.triggerToastMessage(error.error.error.message + " (from OpenAI)");
            this.loader = false;
          }
        }
      );
    }
  }

  assistantSetupFormSubmit(assistantSetup: any) {
    if (
      !assistantSetup.token && !assistantSetup.maxtokens
    ) {
      this.triggerToastMessage(this.appService.getResourceText('V007'));
      return;
    } else {
      this.loader = true;
      var tokenObj = {
        "assistantName": "ChatGPT",
        "token": assistantSetup.token,
        "maxtokens": assistantSetup.maxtokens,
        "model": this.selectedAssistantModel
      }
      this.userManagementService
        .createAssistantToken(tokenObj)
        .subscribe((response: any) => {
          // console.log("response", response);
          // return;
          if (response.statusCode == 200) {
            // console.log("response", response);
            this.triggerToastMessage(response.message);
            this.assistantSetup = { maxtokens: 500, token: '' };
            this.selectedAssistantModel = '';
            this.loader = false;
            return;

          }

        })
    }
    // console.log("assistantSetup", assistantSetup);
  }

  changePasswordFormSubmit(password: any) {
    if (
      !password.oldpassword ||
      !password.newpassword ||
      !password.confirmpassword
    ) {
      this.triggerToastMessage(this.appService.getResourceText('V007'));
      return;
    }
    //  else if (password.oldpassword == password.newpassword) {
    //   this.changepwd.newpassword = '';
    //   this.changepwd.confirmpassword = '';
    //   $("#newpassword").focus();
    //   this.triggerToastMessage(this.appService.getResourceText("B025"));
    //   return;
    // } else if (password.newpassword != password.confirmpassword) {
    //   this.changepwd.confirmpassword = '';
    //   $("#confirmpassword").focus();
    //   this.triggerToastMessage(this.appService.getResourceText("B026"));
    //   return;
    // } else if (this.validatePassword(password.newpassword) && this.errors.length != 0) {
    //   if (this.errors.length > 0) {
    //     this.triggerToastMessage(this.errors.join("<br>"));
    //     return;
    //   }
    // }
    else {
      this.userManagementService
        .changePassword(password)
        .subscribe((response: any) => {
          console.log("response", response);
          // return;
          if (response.statusCode == 200) {
            // this.appService.getResourceText('B024')
            this.triggerToastMessage(response.message);
            setTimeout(() => {
              $('#changePwdFormPopupModal').modal('hide');
              window.location.href = '/login';
            }, 3000);
          } else if (response.statusCode == 201) {
            // this.appService.getResourceText('B025')
            this.triggerToastMessage(response.message);
          } else if (response.statusCode == 202) {
            this.changepwd.newpassword = '';
            this.changepwd.confirmpassword = '';
            // this.appService.getResourceText('B026')
            this.triggerToastMessage(response.message);
          } else if (response.statusCode == 203) {
            this.changepwd = {
              oldpassword: '',
              newpassword: '',
              confirmpassword: '',
            };
            $('#oldpassword').focus();
            this.triggerToastMessage(response.message);
          } else if (response.statusCode == 204) {
            this.changepwd.newpassword = '';
            this.changepwd.confirmpassword = '';
            this.triggerToastMessage(response.message);
          } else {
            this.triggerToastMessage(response);
          }

          //// error res code
          this.triggerToastMessage(response.message);
        });
    }
  }

  jiraLoginFormSubmit(jiraDetails: any) {
    this.getProjectList(localStorage.getItem('publicToken'));
    // console.log('jiraDetails', jiraDetails);
    if (!jiraDetails.username || !jiraDetails.password || !jiraDetails.jiraurl) {
      this.triggerToastMessage(this.appService.getResourceText('V007'));
      return;
    } else {
      let authorizationData = 'Basic ' + btoa(jiraDetails.username + ':' + jiraDetails.password)
      this.JiraUserService
        .jiraLogin(authorizationData, jiraDetails.jiraurl)
        .subscribe((response: any) => {
          // console.log('JIRA response', response);
          let obj = { userId: localStorage.getItem('userID'), username: jiraDetails.username, token: jiraDetails.password, url: jiraDetails.jiraurl }
          this.userManagementService
            .jiraAuthUpdate(obj)
            .subscribe((response: any) => {
              // console.log('jiraAuthUpdate', response);
            });
          this.jiraProjectList = response;
          var jirapro = this.jiraProjectList.find(
            (det: any) => det.name == this.sessionProjectData.jiraProjectDetails.name
          );
          if (jirapro) {
            this.selectedJiraProject = jirapro
          } else {
            this.selectedJiraProject = {}
          }
          this.showJiraprojectList = true;
        });
    }
  }

  getProjectList(token: any) {
    this.ProjectServices.projectsList(token).subscribe((response: any) => {
      // console.log('login res', response);
      if (response.statusCode == 200) {
        // console.log('response project list success', response.record);
        this.doSmartQAProjectList = response.record;
        this.doSmartQAProjectList.sort((a: any, b: any) =>
          a.projectDetails.name.localeCompare(b.projectDetails.name)
        );
      }
    });
  }

  selectJiraProject(pro: any) {
    // console.log('pro details of Jira', pro);
    this.selectedJiraProject = pro;
  }

  selectDoSmartQAProject(pro: any) {
    // console.log('pro details of domartqa', pro);
    this.selectedDoSmartQAProject = pro;
  }

  linkJiraProjectWithDoSmartQAproject(pro: any, jirapro: any) {
    // console.log('pro details of Jira', jirapro);
    // console.log('pro details of domartqa', this.sessionProjectData);
    if (jirapro.id != "" && jirapro.id != undefined && jirapro.id != null) {
      this.sessionProjectData.jiraProjectDetails = { name: jirapro.name, id: jirapro.id, url: this.jiraLogin.jiraurl, key: jirapro.key };
      // console.log('pro details of domartqa', this.sessionProjectData);
      this._sharedService.updateProject(this.sessionProjectData).subscribe((response: any) => {
        // console.log('updateProject res', response);
        this.getProjectTasksList(response.record)
        this.triggerToastJiraUpdate(this.appService.getResourceText('V034'));
        // this.selectedJiraProject = {};
        // this.selectedDoSmartQAProject = { projectDetails: { name: "" }, jiraProjectDetails: { name: "", id: "", url: '',key:'' } };
      });
    }
  }

  unLinkJiraProjectWithDoSmartQAproject(pro: any, jirapro: any) {
    // console.log('pro details of Jira', jirapro);
    // console.log('pro details of domartqa', this.sessionProjectData);
    this.sessionProjectData.jiraProjectDetails = { name: '', id: '', url: '', key: '' };
    // console.log('pro details of domartqa', this.sessionProjectData);
    // if (jirapro.id != "" || jirapro.id != undefined || jirapro.id != null) {
    this._sharedService.updateProject(this.sessionProjectData).subscribe((response: any) => {
      // console.log('updateProject res', response);
      this.triggerToastJiraUpdate(this.appService.getResourceText('V035'));
      this.selectedJiraProject = {};
      // this.selectedDoSmartQAProject = { projectDetails: { name: "" }, jiraProjectDetails: { name: "", id: "", url: '',key:'' } };
    });
    // }
  }

  openMyNotes() {
    if (this.myNotesOpen == false) {
      this.myNotesOpen = true;
    } else {
      this.myNotesOpen = false;
    }
    this.chatGPTOpen = false;
  }

  openChatGPT() {
    if (this.chatGPTOpen == false) {
      this.chatGPTOpen = true;
    } else {
      this.chatGPTOpen = false;
      window.localStorage.removeItem("assistantTool");
    }
    this.myNotesOpen = false;
  }

  readmode(status: any) {
    // console.log('readmode function called', status);
    if (status == false) {
      // var x: any = document.getElementById('readonlyOverLay');
      // x.style.display = 'block';
      this.readStatus = true;
      $('.readOnlyForm :input').prop('disabled', true);
      $('.readOnlyFormPlanner :input').prop('disabled', true);
      $('.readOnlyFormPlanner :checkbox').prop('disabled', false);
      $('.readOnlyForm :button').prop('disabled', false);
      $('.labelReadOnly').attr('disabled', true);
      $('.checkboxReadOnly').attr('disabled', false);
      this.IMcheckboxReadOnly = true;
      $('.mappercheckboxReadOnly').attr('disabled', false);
      $('.mapperReadOnly').css('pointer-events', 'none');
      $('.mapperReadOnly').css('cursor', 'not-allowed');
      $('.readOnlyModeBtn').addClass('active');
    } else {
      // var x: any = document.getElementById('readonlyOverLay');
      // x.style.display = 'none';
      this.readStatus = false;
      $('.readOnlyForm :input').prop('disabled', false);
      $('.readOnlyFormPlanner :input').prop('disabled', false);
      $('.labelReadOnly').attr('disabled', false);
      $('.checkboxReadOnly').attr('disabled', false);
      $('.mappercheckboxReadOnly').attr('disabled', true);
      this.IMcheckboxReadOnly = false;
      $('.mapperReadOnly').css('pointer-events', '');
      $('.mapperReadOnly').css('cursor', 'pointer');
      $('.readOnlyModeBtn').removeClass('active');
    }
  }

  openNav() {
    var x: any = document.getElementById('mySidenav');
    x.style.width = '250px';
    $('.overlayLayer').addClass('active');
  }
  // function to close activity of myNote or supernote
  // $(document).on('hide.bs.modal', '#myNote', function () {
  //   this.createActivity('XX');
  // });

  // function to close activity of notification
  // $(document).on('hide.bs.modal', '#notifySection', function () {
  //   this.createActivity('XX');
  // });

  closeNav() {
    var x: any = document.getElementById('mySidenav');
    x.style.width = '0px';
    $('.collapse.in').collapse('hide');
    $('.overlayLayer').removeClass('active');
  }

  closeHamburgerMenu() {
    $('#hamburgerMenu').modal('hide');
    var x: any = document.getElementById('mySidenav');
    x.style.width = '0px';
    $('.collapse.in').collapse('hide');
    $('.overlayLayer').removeClass('active');
  }

  // $('[data-parent="#accordion1"]').click(function () {
  //   $('.collapse.in').collapse('hide')
  // });

  // $('[data-parent="#accordion2"]').click(function () {
  //   $('.collapse.in .submenu').collapse('hide')
  // });

  // $('[data-parent="#accordion3"]').click(function () {
  //   $('.collapse.in .subminimenu').collapse('hide')
  // });

  // $('.overlayLayer').on('click', function () {
  //   this.closeNav();
  //   $('.overlayLayer').removeClass('active');
  // });

  myFunction(dashId: any) {
    var dashName = dashId;
    $('.panelDiv').removeClass('active');
    $('#' + dashName).addClass('active');
  }

  updateHistorySession(createdprojId: any) {
    var taskDetails = this.sessionProjectData.tasks;
    var completedTasks = [];
    for (var i = 0; i < taskDetails.length; i++) {
      if (taskDetails[i].completed == true && taskDetails[i].history != true) {
        taskDetails[i].history = true;
        taskDetails[i].status = 3;
        completedTasks.push({ desc: taskDetails[i].task_desc });
      }
    }
    var projectId = window.localStorage.getItem("projectID");
    if (completedTasks.length != 0) {
      var taskDet = {
        updatedHistory: completedTasks,
        projectId: projectId,
      };
      console.log('before triggerToast call41', taskDet);
      this.ProjectServices.updateHistorySession(taskDet).subscribe(
        (response: any) => {
          // console.log('updateHistorySession res', response);
          if (response.statusCode === 200) {
            this.addHistorySession(projectId);
            this.getHistorySession(projectId);
          } else if (response.statusCode === 401) {
            // console.log('before triggerToast call41');
            this.triggerToast(this.appService.getResourceText('B000'));
            setTimeout(function () {
              window.location.href = '/login';
            }, 3000);
          } else if (response.statusCode === 500) {
            // this.triggerToast(this.appService.getResourceText("B002"));
          }
        }
      );
    } else {
      if (completedTasks.length == 0) {
        if (createdprojId == undefined || createdprojId == '') {
          this.getHistorySession(projectId);
          this.addHistorySession(projectId);
        } else {
          this.getHistorySession(createdprojId);
          this.addHistorySession(createdprojId);
        }
      } else {
        this.getHistorySession(createdprojId);
        this.addHistorySession(createdprojId);
      }
    }
  }

  addHistorySession(createdprojId: any) {
    // console.log('addHistorySession projetc id', createdprojId);

    this.ProjectServices.addHistorySession(createdprojId).subscribe(
      (response: any) => {
        // console.log('addHistorySession res', response);
        if (response.statusCode === 200) {
          localStorage.setItem('HistorySessionID', response.sessionid);
        } else if (response.statusCode === 401) {
          // console.log('before triggerToast call43');
          this.triggerToast(this.appService.getResourceText('B000'));
          setTimeout(function () {
            window.location.href = '/login';
          }, 3000);
        } else if (response.statusCode === 500) {
          // this.triggerToast(this.appService.getResourceText('B002'));
        }
      }
    );
  }
  getHistorySession(createdprojId: any) {
    // console.log('getHistorySession projetc id', createdprojId);
    var currentProjectID = window.localStorage.getItem("projectID");
    this.ProjectServices.getHistorySession(createdprojId).subscribe(
      (response: any) => {
        // console.log('getHistorySession res', response);
        if (response.statusCode === 200) {
          for (var k = 0; k < response.records.length; k++) {
            if (response.records[k].history.length != 0) {
              this.sessionHistoryArray.push(response.records[k]);
            }
          }
        } else if (response.statusCode === 401) {
          this.triggerToast(this.appService.getResourceText('B000'));
          // localStorage.clear();
          setTimeout(function () {
            window.location.href = '/login';
          }, 3000);
        } else if (response.statusCode === 500) {
          // this.triggerToast(this.appService.getResourceText('B002'));
        }
      }
    );
  }

  // API calling to get a public widget full details by using widget id
  getPublicWidgetContentByID(widget: any) {
    // console.log('public id', widgetID);
    this.selectedWidgetID = widget._id;
    this.selectedWidgetType = widget.repo;
    this.widget.controller.showWidgets = false;
    // ProjectService.getpublicWidgetContentByID(this.selectedWidgetID)
    //   .then(
    //     function onSuccess(response) {
    //       if (response.status === 200) {
    //         console.log('getpublicWidgetContentByID response', response);
    //         this.selectedWidgetDetails = response.record;
    //         this.generateWidgetHTML(response.record, 'Public');
    //         // this.widget.controller.generateWidgetDetailDisplay(response.record, 'Public');
    //       }
    //     },

    //     function onError(response) {
    //       if (response.status === 401) {
    //         console.log('before triggerToast call49');
    //         triggerToast(this.appService.getResourceText("B000"));
    //         // localStorage.clear();
    //         setTimeout(function () { window.location.href = "/login" }, 3000);
    //       } else if (response.status === 500) {
    //         console.log('before triggerToast call50');
    //         // triggerToast(this.appService.getResourceText("B002"));
    //       }
    //     }
    //   );
  }

  // API calling to get a private widget full details by using widget id
  getPrivateWidgetContentByID(widget: any) {
    // console.log('private id', widgetID);
    this.selectedWidgetID = widget._id;
    this.selectedWidgetType = widget.repo;
    this.widget.controller.showWidgets = false;
    // ProjectService.getPrivateWidgetContentByID(this.selectedWidgetID)
    //   .then(
    //     function onSuccess(response) {
    //       if (response.status === 200) {
    //         console.log('getpublicWidgetContentByID response', response);
    //         this.selectedWidgetDetails = response.record;
    //         this.generateWidgetHTML(response.record, 'Private');

    //       }
    //     },

    //     function onError(response) {
    //       if (response.status === 401) {
    //         console.log('before triggerToast call49');
    //         triggerToast(this.appService.getResourceText("B000"));
    //         // localStorage.clear();
    //         setTimeout(function () { window.location.href = "/login" }, 3000);
    //       } else if (response.status === 500) {
    //         console.log('before triggerToast call50');
    //         // triggerToast(this.appService.getResourceText("B002"));
    //       }
    //     }
    //   );
  }

  // generate HTML data to show widget info in widget details part of widget modal
  generateWidgetHTML(widgetData: any) {
    // this.widgetContent = "<div>";
    this.widgetContent = '<span><b>Name</b></span></br>';
    this.widgetContent +=
      '<span>' + widgetData.name + ' (' + widgetData.repo + ')</span></br>';
    this.widgetContent += '<span><b>Description</b></span></br>';
    this.widgetContent += '<span>' + widgetData.description + '</span></br>';
    this.widgetContent += '<span><b>Category</b></span></br>';
    this.widgetContent += '<span>' + widgetData.category + '</span></br>';
    if (widgetData.type != 'Issue') {
      this.widgetContent += '<span><b>Conditions</b></span></br>';
      this.widgetContent += '<span>' + widgetData.conditions + '</span></br>';
      this.widgetContent += '<span><b>Criteria</b></span></br>';
      this.widgetContent += '<span>' + widgetData.criteria + '</span></br>';
    }
    this.widgetContent += '<span><b>Issues</b></span></br>';
    this.widgetContent += '<span>' + widgetData.issues + '</span></br>';
    this.widgetContent += '<span><b>Heuristics</b></span></br>';
    this.widgetContent += '<span>' + widgetData.heuristics + '</span></br>';
    this.widgetContent += '<span><b>Actions</b></span></br>';
    this.widgetContent += '<span>' + widgetData.actions + '</span></br>';
    this.widgetContent += '<span><b>Data</b></span></br>';
    this.widgetContent += '<span>' + widgetData.data + '</span></br>';
    this.widgetContent += '<span><b>Links</b></span></br>';
    this.widgetContent += '<span>' + widgetData.links + '</span></br>';
    // console.log(this.widgetContent);
    this.widget.controller.generateWidgetDetailDisplay(
      this.widgetContent,
      widgetData.repo
    );
  }

  // generate HTML data to append widget info in designer notepad
  generateWidgetHTMLForDesignerNotepad(widgetData: any) {
    this.widgetContentDesigner = '<span><b>Name</b></span>';
    this.widgetContentDesigner +=
      '<span>' + widgetData.name + ' (' + widgetData.repo + ')</span></br>';
    this.widgetContentDesigner += '<span><b>Description</b></span>';
    this.widgetContentDesigner +=
      '<span>' + widgetData.description + '</span></br>';
    this.widgetContentDesigner += '<span><b>Category</b></span>';
    this.widgetContentDesigner +=
      '<span>' + widgetData.category + '</span></br>';
    if (widgetData.type != 'Issue') {
      this.widgetContentDesigner += '<span><b>Conditions</b></span>';
      this.widgetContentDesigner +=
        '<span>' + widgetData.conditions + '</span></br>';
      this.widgetContentDesigner += '<span><b>Criteria</b></span>';
      this.widgetContentDesigner +=
        '<span>' + widgetData.criteria + '</span></br>';
    }
    this.widgetContentDesigner += '<span><b>Issues</b></span>';
    this.widgetContentDesigner += '<span>' + widgetData.issues + '</span></br>';
    this.widgetContentDesigner += '<span><b>Heuristics</b></span>';
    this.widgetContentDesigner +=
      '<span>' + widgetData.heuristics + '</span></br>';
    this.widgetContentDesigner += '<span><b>Actions</b></span>';
    this.widgetContentDesigner +=
      '<span>' + widgetData.actions + '</span></br>';
    this.widgetContentDesigner += '<span><b>Data</b></span>';
    this.widgetContentDesigner += '<span>' + widgetData.data + '</span></br>';
    this.widgetContentDesigner += '<span><b>Links</b></span>';
    this.widgetContentDesigner += '<span>' + widgetData.links + '</span></br>';
    return this.widgetContentDesigner;
  }

  usePublicAndPrivateWidget() {
    // console.log('Type', this.selectedWidgetType);
    // this.selectedWidgetID = widgetID;
    if (this.selectedWidgetID) {
      // this.widget.controller.showWidgets = false;
      // ProjectService.publicandPrivateWidgetUseCount(this.selectedWidgetID, this.selectedWidgetType)
      //   .then(
      //     function onSuccess(response) {
      //       if (response.statusCode === 200) {
      //         // console.log('getpublicWidgetContentByID response', response);
      //         // this.widget.controller.generateWidgetDetailDisplay(response.record, 'Private');
      //         this.updateDesignerContent();
      //       }
      //     },
      //     function onError(response) {
      //       if (response.status === 401) {
      //         console.log('before triggerToast call49');
      //         triggerToast(this.appService.getResourceText("B000"));
      //         // localStorage.clear();
      //         setTimeout(function () { window.location.href = "/login" }, 3000);
      //       } else if (response.status === 500) {
      //         console.log('before triggerToast call50');
      //         // triggerToast(this.appService.getResourceText("B002"));
      //       }
      //     }
      //   );
    }
  }

  loadMappersModel(val: any) {
    // this.interactionMapper.controller.manageMappedEUTs();
    // if (val == 'persona') {
    //   this.personaMapper.controller.selectedEUTMapping();
    // } else {
    //   this.personaMapper.controller.selectedPersonaMapping();
    // }
    this.personaMapperMindmap.model.loadPersonaMap();
    this.personaMapperMindmap.model.loadPersonaMapUI();
    this.personaMapper.model.loadPersonaMap();
    this.personaMapper.model.loadPersonaMapUI();
  }

  loadInteractionMapper() {
    this.interactionMapperMindmap.controller.getMappingInteraction();
    this.interactionMapperMindmap.model.loadInteractionMap();
    this.interactionMapperMindmap.model.loadInteractionMapUI();
    // this.interactionMapper.controller.getMappingInteraction();
    this.interactionMapper.model.loadInteractionMap();
    this.interactionMapper.model.loadInteractionMapUI();
  }
  personaTreeBranchIcons(status: any) {
    if (status == 'TF') {
      if (this.TFToggleStatus) {
        $('.TFstage2').hide();
        this.TFToggleStatus = false;
      } else {
        $('.TFstage2').show();
        this.TFToggleStatus = true;
      }
      $('.iconsTF').toggleClass('fa-plus-circle fa-minus-circle');
    } else if (status == 'UR') {
      if (this.URToggleStatus) {
        $('.URstage2').hide();
        this.URToggleStatus = false;
      } else {
        $('.URstage2').show();
        this.URToggleStatus = true;
      }
      $('.iconsUR').toggleClass('fa-plus-circle fa-minus-circle');
    } else if (status == 'BF') {
      if (this.BFToggleStatus) {
        $('.BFstage2').hide();
        this.BFToggleStatus = false;
      } else {
        $('.BFstage2').show();
        this.BFToggleStatus = true;
      }
      $('.iconsBF').toggleClass('fa-plus-circle fa-minus-circle');
    } else if (status == 'XX') {
      if (this.XXToggleStatus) {
        $('.XXstage2').hide();
        this.XXToggleStatus = false;
      } else {
        $('.XXstage2').show();
        this.XXToggleStatus = true;
      }
      $('.iconsXX').toggleClass('fa-plus-circle fa-minus-circle');
    }
  }

  interactionTreeBranchIcons(status: any) {
    // console.log('interactionTreeBranchIcons status', status);

    if (status == 'TF') {
      if (this.interactionTFToggleStatus) {
        $('.TFstage2Inter').hide();
        this.interactionTFToggleStatus = false;
      } else {
        $('.TFstage2Inter').show();
        this.interactionTFToggleStatus = true;
      }
      $('.iconsTF').toggleClass('fa-plus-circle fa-minus-circle');
    } else if (status == 'UR') {
      if (this.interactionURToggleStatus) {
        $('.URstage2Inter').hide();
        this.interactionURToggleStatus = false;
      } else {
        $('.URstage2Inter').show();
        this.interactionURToggleStatus = true;
      }
      $('.iconsUR').toggleClass('fa-plus-circle fa-minus-circle');
    } else if (status == 'BF') {
      if (this.interactionBFToggleStatus) {
        $('.BFstage2Inter').hide();
        this.interactionBFToggleStatus = false;
      } else {
        $('.BFstage2Inter').show();
        this.interactionBFToggleStatus = true;
      }
      $('.iconsBF').toggleClass('fa-plus-circle fa-minus-circle');
    }
    else if (status == 'XX') {
      if (this.interactionBFToggleStatus) {
        $('.BFstage2Inter').hide();
        this.interactionBFToggleStatus = false;
      } else {
        $('.BFstage2Inter').show();
        this.interactionBFToggleStatus = true;
      }
      $('.iconsXX').toggleClass('fa-plus-circle fa-minus-circle');
    }
  }

  scopeTreeBranchIcons(status: any) {
    if (status == 'TF') {
      if (this.scopeTFToggleStatus) {
        $('.TFstage2Scope').hide();
        this.scopeTFToggleStatus = false;
      } else {
        $('.TFstage2Scope').show();
        this.scopeTFToggleStatus = true;
      }
      $('.iconsTF').toggleClass('fa-plus-circle fa-minus-circle');
    } else if (status == 'UR') {
      if (this.scopeURToggleStatus) {
        $('.URstage2Scope').hide();
        this.scopeURToggleStatus = false;
      } else {
        $('.URstage2Scope').show();
        this.scopeURToggleStatus = true;
      }
      $('.iconsUR').toggleClass('fa-plus-circle fa-minus-circle');
    } else if (status == 'BF') {
      if (this.scopeBFToggleStatus) {
        $('.BFstage2Scope').hide();
        this.scopeBFToggleStatus = false;
      } else {
        $('.BFstage2Scope').show();
        this.scopeBFToggleStatus = true;
      }
      $('.iconsBF').toggleClass('fa-plus-circle fa-minus-circle');
    } else if (status == 'XX') {
      if (this.scopeXXToggleStatus) {
        $('.XXstage2Scope').hide();
        this.scopeXXToggleStatus = false;
      } else {
        $('.XXstage2Scope').show();
        this.scopeXXToggleStatus = true;
      }
      $('.iconsXX').toggleClass('fa-plus-circle fa-minus-circle');
    }
  }

  loadScopeMappersModel(val: any) {
    // if (val == 'attribute') {
    //   this.scopeMapper.controller.selectedEUTMapping();
    // } else {
    //   this.scopeMapper.controller.selectedScopeMapping();
    // }
    this.scopeMapper.model.loadScopeMap();
    this.scopeMapper.model.loadScopeMapUI();
  }

  //this function will toggle the status of allocating/deallocating a task for the session
  allocateTaskInProject(task: any) {
    var status = task.status == '1' ? '0' : '1';
    task.status = status;
    var taskdetails = { _id: task._id, status: status };

    // ProjectService.allocateTaskInProject(taskdetails).then(
    //   function onSuccess(response) {
    //     this.getTaskList();
    //   },
    //   function onError(response) {
    //     triggerToast(response.data);
    //   }
    // );
  }

  // resetFeedbackForm() {
  //   var iframe: any = document.getElementById('feedbackForm');
  //   iframe.src = iframe.src;
  // }

  //function for opening chatbox modal when users are more then one.
  openChatBoxModal() {
    $('#chatPopupModal').modal('show');
    this.selectAllToChatbox(true);
  }

  resetExRowColorOnFilter() {
    // console.log('resetRowColoronFilter called');
    $('#validatorScenTable tr').removeClass('active');
  }

  resetDesignerRowColorOnFilter() {
    // console.log('resetDesignerRowColorOnFilter called');
    $('#designerScenTable tr').removeClass('active');
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  welcomeNoteClose() {
    // console.log('welcomeNoteClose fn called');
    var idObj: any = { userId: this.myUserID };
    this.userManagementService
      .newLoginUpdate(idObj)
      .subscribe((response: any) => {
        if (response.statusCode === 200) {
          $('#welcomeNotePopup').modal('hide');
          this.loginDetails.newlogin = 1;
          localStorage.setItem(
            'loginDetails',
            JSON.stringify(this.loginDetails)
          );
        }
      });
  }

  editorChanged(event: EditorChangeContent | EditorChangeSelection) {
  }

  // sendFeedback(){
  //   console.log("data",this.feedbackEditorContent);
  // }
  // $("#chooseFileImage").on('change', function () {
  //   var selectedFile = this.files[0];
  //   selectedFile.convertToBase64(function (base64: any) {
  //     console.log(base64);
  //     this.imageBC64 = base64;
  //   })
  // });
  choosenImage(event: any) {
    const fileToLoad = event.target.files[0];
    console.log("fileToLoad", fileToLoad);
    $('#noFileImage').html(fileToLoad.name);
  }

  sendFeedback() {
    // feedbackSubject = document.getElementById("subjectInput").value;
    // feedbackType = document.getElementById("feedbackMethod").value;
    // console.log('feedbackcontent', this.feedbackEditorContent);
    // console.log('feedbackMethod', this.feedbackMethod);
    // console.log('feedbackSubject', this.feedbackSubject);
    // if (feedbackSubject == "" || feedbackMessage == "" || feedbackMessage == '<p><br></p>') {
    //   if (feedbackSubject == "" && (feedbackMessage == "" || feedbackMessage == '<p><br></p>')) {
    //     feedbackErrorMessage = 'Please enter subject line and email content.';
    //     triggerToast(feedbackErrorMessage);
    //   } else if (feedbackSubject == "") {
    //     feedbackErrorMessage = 'Please enter subject line';
    //     triggerToast(feedbackErrorMessage);
    //   } else if (feedbackMessage == "" || feedbackMessage == '<p><br></p>') {
    //     feedbackErrorMessage = 'Please enter email content';
    //     triggerToast(feedbackErrorMessage);
    //   }
    // } else {
    // console.log("this.feedbackEditorContent", this.feedbackEditorContent);
    if (this.feedbackEditorContent == "" || this.feedbackEditorContent == '<p><br></p>') {
      this.feedbackErrorMessage = 'Please enter feedback content';
      this.triggerToast(this.feedbackErrorMessage);
      return;

    }
    var imageBC64 = 'base64qweuqdf234234';
    var feedbackMessage;
    feedbackMessage =
      this.feedbackEditorContent +
      "<p>Cheers</p><p>doSmartQA</p><a href = 'mailto:support@dosmartqa.stagsoftware.net'>support@dosmartqa.stagsoftware.net</a>";
    var token = window.localStorage.getItem('publicToken');
    var projectID = window.localStorage.getItem('projectID');
    var jsonObjects = {
      subject: "Feedback",
      content: feedbackMessage,
      type: this.feedbackMethod,
      image: "https://www.thewowstyle.com/wp-content/uploads/2015/01/nature-images.jpg",
    };
    this.ProjectServices.addFeedback(jsonObjects, token).subscribe(
      (response: any) => {
        this.feedbackEditorContent = '';
        this.feedbackErrorMessage =
          'Feedback sent successfully.';
        this.triggerToast(this.feedbackErrorMessage);
        $('#noFileImage').html('No file chosen');
      }
    );
    // jQuery.ajax({
    //   url: serverUrl + "/addFeedback",
    //   type: "POST",
    //   async: true,
    //   processData: false,
    //   data: JSON.stringify(jsonObjects),
    //   dataType: "json",
    //   cache: false,
    //   contentType: "application/json",
    //   headers: {
    //     "Authorization": token,
    //   },
    //   success: function (result) {
    //     // console.log('result', result);
    //     feedbackErrorMessage = 'Email sent successfully, check your email box.';
    //     feedbackSubject = "";
    //     feedbackMessage = "";
    //     imageBC64 = "";
    //     document.getElementById("subjectInput").value = feedbackSubject;
    //     document.getElementById("feedbackMethod").value = 'Suggestion';
    //     $(".file-upload").removeClass('active');
    //     $("#noFileImage").text("No file chosen");
    //     quill.setText('');
    //     triggerToast(feedbackErrorMessage);
    //   }
    // });
    // }
  }

  updateLanguage(language: any) {
    localStorage.setItem('language', language);
    this.cookieService.set('language', language);
    const browserLang = language;
    this.translate.use(browserLang.match(/en|jp/) ? browserLang : language);
  }

  checkScenarioCount(scenarios: any, listOfEUTs: any) {
    // console.log('scenarios', scenarios);
    // console.log('listOfEUTs', listOfEUTs);
    for (let a = 0; a < listOfEUTs.length; a++) {
      if (
        listOfEUTs[a].scenarioCount === 0 ||
        listOfEUTs[a].scenarioCount == undefined
      ) {
        for (let b = 0; b < scenarios.length; b++) {
          if (listOfEUTs[a].eID === scenarios[b].eID) {
            listOfEUTs[a].scenarioCount++;
          }
        }
      }
    }
  }

  /////   close

  sendJson(selectedEntityIDDetails: any) {
    var selectedEntity = this.modelData.EUTdetails.find(
      (eut: any) => eut.eID == selectedEntityIDDetails.eID
    );
    if (selectedEntity.notes != '') {
      this.notesEditorContent = selectedEntity.notes;
    } else {
      this.notesEditorContent = '';
    }
    var mindMapList = ["personas", "summary", "interactions", "specs", "test type", "attributes", "extras"];
    this.selectedEntityScenarios = [];
    this.selectedEntityScenarioTestTypes = [];
    for (var c = 0; c < this.modelData.scenarios.length; c++) {
      if (selectedEntityIDDetails.eID == this.modelData.scenarios[c].eID) {
        this.selectedEntityScenarios.push(this.modelData.scenarios[c]);
        var isPresent = this.selectedEntityScenarioTestTypes.findIndex((a: any) => a.symbol == this.modelData.scenarios[c].attribute.symbol);
        if (isPresent > -1) {
        } else {
          this.selectedEntityScenarioTestTypes.push(this.modelData.scenarios[c].attribute);
        }
      }
    }
    for (var d = 0; d < this.selectedEntityScenarios.length; d++) {
      for (var e = 0; e < this.levelwiseCount.length; e++) {
        if (this.selectedEntityScenarios[d].attribute.level == this.levelwiseCount[e].level) {
          this.levelwiseCount[e].count++;
        }
      }
      for (var f = 0; f < this.TypeswiseCount.length; f++) {
        if (this.selectedEntityScenarios[d].cr == this.TypeswiseCount[f].type) {
          this.TypeswiseCount[f].count++;
        }
      }
      for (var g = 0; g < this.TestTypewiseCount.length; g++) {
        if (this.selectedEntityScenarios[d].attribute.symbol == this.TestTypewiseCount[g].test) {
          this.TestTypewiseCount[g].count++;
        }
      }
    }
    this.childrenArray = [];
    for (var i = 0; i < mindMapList.length; i++) {
      if (mindMapList[i] == "test type") {
        let modulesObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
        };
        let modulesSubchild: any = []
        for (var j = 0; j < this.selectedEntityScenarioTestTypes.length; j++) {
          let module: any = {};
          module['topic'] = this.selectedEntityScenarioTestTypes[j].name
          module['id'] = this.selectedEntityScenarioTestTypes[j].symbol
          module['expanded'] = true
          let entitySubchild: any = []
          for (var l = 0; l < this.selectedEntityScenarios.length; l++) {
            if (this.selectedEntityScenarioTestTypes[j].symbol == this.selectedEntityScenarios[l].attribute.symbol) {
              let entity: any = {};
              entity['topic'] = this.selectedEntityScenarios[l].description
              entity['id'] = this.selectedEntityScenarios[l].scenID

              entitySubchild.push(entity)
            }
          }
          if (entitySubchild.length > 10) {
            module['expanded'] = false
          }
          module['children'] = entitySubchild;
          module['topic'] = this.selectedEntityScenarioTestTypes[j].name + ' / ' + this.selectedEntityScenarioTestTypes[j].level + ' (' + entitySubchild.length + ')';
          modulesSubchild.push(module);
        };
        modulesObject['children'] = modulesSubchild;
        modulesObject['topic'] = mindMapList[i] + ' (' + modulesSubchild.length + ')';
        this.childrenArray.push(modulesObject);
      }
      if (mindMapList[i] == "personas") {
        let personaObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4()
        }
        let personasSubchild: any = [];
        for (let k = 0; k < this.modelData.persona.length; k++) {
          for (let a = 0; a < this.modelData.personaMap.length; a++) {
            if (this.modelData.persona[k].pType == this.modelData.personaMap[a].pType && selectedEntityIDDetails.eID == this.modelData.personaMap[a].eID) {
              let persona: any = {};
              persona['topic'] = this.modelData.persona[k].pName
              persona['id'] = this.modelData.persona[k].pType
              personasSubchild.push(persona);
            }
          }

        }
        personaObject['children'] = personasSubchild;
        personaObject['topic'] = mindMapList[i] + ' (' + personasSubchild.length + ')';
        this.childrenArray.push(personaObject);
      }
      if (mindMapList[i] == "specs") {
        let specsObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
        }
        let specs = ["bc", "ac", "outcomes", "pIssues"]
        let specsSubchild: any = [];
        for (let a = 0; a < specs.length; a++) {
          var foundEntityDetails = this.modelData.EUTdetails.find((entity: any) => entity.eID == selectedEntityIDDetails.eID)
          if (foundEntityDetails) {
            let specsObj: any = {};
            if (specs[a] == 'bc') {
              specsObj['topic'] = 'Behavioural conditions : ' + foundEntityDetails.bc
            }
            if (specs[a] == 'ac') {
              specsObj['topic'] = 'Acceptance criteria : ' + foundEntityDetails.ac
            }
            if (specs[a] == 'outcomes') {
              specsObj['topic'] = 'Inputs & Outcomes : ' + foundEntityDetails.outcomes
            }
            if (specs[a] == 'pIssues') {
              specsObj['topic'] = 'Potential issues : ' + foundEntityDetails.pIssues
            }
            specsObj['id'] = this.uuidv4();
            specsSubchild.push(specsObj);
          }
        }
        specsObject['children'] = specsSubchild;
        specsObject['topic'] = mindMapList[i] + ' (4)';
        this.childrenArray.push(specsObject);
      }
      if (mindMapList[i] == "attributes") {
        let attributesObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4()
        }
        let attributeSubchild: any = [];
        let specifiedAttributesArray: any = [];
        var foundEntityDetails = this.modelData.EUTdetails.find((entity: any) => entity.eID == selectedEntityIDDetails.eID)
        if (foundEntityDetails) {
          if (foundEntityDetails.testTypes) {
            specifiedAttributesArray = foundEntityDetails.testTypes;
          }
        }
        for (let k = 0; k < this.Config.listOfAttributesUpdated.length; k++) {

          for (let b = 0; b < specifiedAttributesArray.length; b++) {
            if (this.Config.listOfAttributesUpdated[k].symbol == specifiedAttributesArray[b].symbol) {
              let attribute: any = {};
              attribute['topic'] = this.Config.listOfAttributesUpdated[k].name + ' : ' + specifiedAttributesArray[b].desc
              attribute['id'] = this.uuidv4()
              attributeSubchild.push(attribute);
            }
          }

        }
        attributesObject['children'] = attributeSubchild;
        attributesObject['topic'] = mindMapList[i] + ' (' + attributeSubchild.length + ')';
        this.childrenArray.push(attributesObject);
      }
      if (mindMapList[i] == "interactions") {
        let interactionObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
        }
        let interactionSubchild: any = [];
        for (var l = 0; l < this.entityTypes.length; l++) {
          let entitySubchild: any = []
          let entity: any = {};
          entity['topic'] = this.entityTypes[l]
          entity['id'] = this.entityTypes[l]
          for (let a = 0; a < this.modelData.interactionMap.length; a++) {
            if (selectedEntityIDDetails.eID == this.modelData.interactionMap[a].eut1) {
              if (this.entityTypes[l] == this.getEntityType(this.modelData.interactionMap[a].eut2)) {
                var foundEntityDetails = this.modelData.listOfEUTs.find((entity: any) => entity.eID == this.modelData.interactionMap[a].eut2)
                if (foundEntityDetails) {
                  let interact: any = {};
                  interact['topic'] = foundEntityDetails.eName
                  interact['id'] = foundEntityDetails.eID
                  entitySubchild.push(interact);
                }
              }
            }
          }
          entity['children'] = entitySubchild;
          entity['topic'] = this.entityTypes[l] + ' (' + entitySubchild.length + ')';
          interactionSubchild.push(entity);
        }
        interactionObject['children'] = interactionSubchild;
        interactionObject['topic'] = mindMapList[i] + ' (' + interactionSubchild.length + ')';
        this.childrenArray.push(interactionObject);

      }
      if (mindMapList[i] == "summary") {
        let interactionObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
        }
        let interactionSubchild: any = [];
        for (var l = 0; l < this.summaryTypes.length; l++) {
          let entitySubchild: any = []
          let entity: any = {};
          entity['topic'] = this.summaryTypes[l]
          entity['id'] = this.summaryTypes[l]
          if (this.summaryTypes[l] == 'By Level') {
            for (let a = 0; a < this.levelwiseCount.length; a++) {
              if (this.levelwiseCount[a].count > 0) {
                let interact: any = {};
                interact['topic'] = this.levelwiseCount[a].level + ' (' + this.levelwiseCount[a].count + ')'
                interact['id'] = this.levelwiseCount[a].level
                entitySubchild.push(interact);
              }
            }
          }
          if (this.summaryTypes[l] == 'By Type') {
            for (let a = 0; a < this.TypeswiseCount.length; a++) {
              if (this.TypeswiseCount[a].count > 0) {
                let interact: any = {};
                interact['topic'] = this.TypeswiseCount[a].type + ' (' + this.TypeswiseCount[a].count + ')'
                interact['id'] = this.TypeswiseCount[a].type
                entitySubchild.push(interact);
              }

            }
          }
          if (this.summaryTypes[l] == 'By Test') {
            for (let a = 0; a < this.TestTypewiseCount.length; a++) {
              if (this.TestTypewiseCount[a].count > 0) {
                let interact: any = {};
                interact['topic'] = this.TestTypewiseCount[a].name + ' (' + this.TestTypewiseCount[a].count + ')'
                interact['id'] = this.TestTypewiseCount[a].name
                entitySubchild.push(interact);
              }
            }
          }
          entity['children'] = entitySubchild;
          entity['topic'] = this.summaryTypes[l] + ' (' + entitySubchild.length + ')';
          interactionSubchild.push(entity);
        }
        interactionObject['children'] = interactionSubchild;
        interactionObject['topic'] = mindMapList[i] + ' (' + interactionSubchild.length + ')';
        this.childrenArray.push(interactionObject);
      }
      if (mindMapList[i] == "extras") {
        this.editorContentText = this.htmlToTextWithLineBreaks(this.notesEditorContent);
        // Split the text by line breaks
        const separatedText = this.editorContentText.split('\n');
        // Filter out empty lines and trim whitespace
        this.filteredText = separatedText
          .filter((line: any) => line.trim() !== '');
        this.finalResultArray = [];
        let currentKey = null;
        let currentValues = [];
        for (const item of this.filteredText) {
          if (item.startsWith("@")) {
            // If an item starts with '@', it's a new key
            if (currentKey) {
              this.finalResultArray.push({ key: currentKey.slice(1), values: currentValues });
            }
            currentKey = item;
            currentValues = [];
          } else {
            currentValues.push(item);
          }
        }
        // Push the last set of values
        if (currentKey) {
          this.finalResultArray.push({ key: currentKey.slice(1), values: currentValues });
        }
        if (this.finalResultArray.length > 0) {
          for (var i = 0; i < this.finalResultArray.length; i++) {
            if (this.finalResultArray[i].key.toLowerCase() != "personas" && this.finalResultArray[i].key.toLowerCase() != "attributes") {
              let personaObject: any = {
                "topic": this.finalResultArray[i].key,
                "id": this.uuidv4(),
                "style": { fontSize: '15', color: '#3298db', background: '#ecf0f1' },
              }
              let personasSubchild: any = [];

              for (let a = 0; a < this.finalResultArray[i].values.length; a++) {
                let persona: any = {};
                persona['topic'] = this.finalResultArray[i].values[a]
                persona['id'] = this.uuidv4(),

                  personasSubchild.push(persona);
              }
              personaObject['children'] = personasSubchild;
              personaObject['topic'] = this.finalResultArray[i].key + '(' + this.finalResultArray[i].values.length + ')';
              this.childrenArray.push(personaObject);
            }
          }

        }
      }
    }
    this.nodeData = {
      "id": selectedEntityIDDetails.eID,
      "topic": selectedEntityIDDetails.eName,
      "root": true,
      "children": this.childrenArray
    };
    this.mindMapData = {
      "nodeData": {
        "id": "8ae27e0480b98558",
        "topic": "Entity",
        "root": true,
        "children": [
          {
            "topic": "Personas",
            "id": "8ae28030353a5bd1",
            "children": [
              {
                "topic": "Admin",
                "id": "8ae281d371bbd6e8"
              },
              {
                "topic": "Manager",
                "id": "8ae28323068d2ca4"
              }
            ]
          },
          {
            "topic": "EUT 1",
            "id": "8ae285dc1ebc3093"
          }
        ]
      },
      "linkData": {},
      "direction": 0,
      "theme": {
        "name": "Latte",
        "palette": [
          "#dd7878",
          "#ea76cb",
          "#8839ef",
          "#e64553",
          "#209fb5",
        ],
        "cssVar": {
          "--main-color": "#444446",
          "--main-bgcolor": "#ffffff",
          "--color": "#777777",
          "--bgcolor": "#f6f6f6"
        }
      }
    };
    this.mindMapData['nodeData'] = this.nodeData;

    var mindMapData = {
      "projectID": selectedEntityIDDetails.eID,
      "projectJson": this.mindMapData,
      "projectName": this.modelData.projectDetails.name
    }

    this.ProjectServices.addMindMappingData(mindMapData).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          const url = 'http://dosmartqa.stagsoftware.net:4009/?projectID=' + mindMapData.projectID
          window.open(url, '_blank');
        } else if (response.statusCode === 500) {
        }
      }
    );

  }
  getEntityType(eID: any) {
    var index = this.modelData.listOfEUTs.find((eut: any) => eut.eID == eID)
    if (index) {
      return index.eType
    } else {
      return '';
    }
  }
  htmlToTextWithLineBreaks(htmlString: any) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Replace <br> tags with newline characters
    const brTags = tempDiv.querySelectorAll('br');
    brTags.forEach(br => {
      if (br.parentNode) {
        const newLine = document.createElement('p');
        br.parentNode.replaceChild(newLine, br);
      }
    });

    // Replace <p> tags with newline characters
    const pTags = tempDiv.querySelectorAll('p');
    pTags.forEach(p => {
      p.outerHTML = '\n' + p.innerHTML + '\n';
    });

    return tempDiv.textContent || tempDiv.innerText || '';
  }
}


